{
  "app": {
    "title": "Journix SaaS Platform Admin",
    "loading": "Loading"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "remove": "Remove",
    "create": "Create",
    "edit": "Edit",
    "close": "Close",
    "back": "Back",
    "next": "Next",
    "retry": "Retry",
    "search": "Search",
    "filter": "Filter",
    "reset": "Reset",
    "yes": "Yes",
    "no": "No",
    "open": "Open",
    "copy": "Copy",
    "copied": "Copied",
    "dismiss": "Dismiss",
    "loading": "Loading",
    "reference": "Reference",
    "actions": "Actions",
    "optional": "Optional",
    "more": "More",
    "menu": "Menu",
    "language": "Language",
    "groups": "Groups",
    "disabled": "Disabled",
    "hexColor": {
      "invalid": "Enter a hex colour like #0f6e56",
      "copy": "Copy {{label}} hex",
      "picker": "{{label}} colour picker",
      "notSet": "Not set",
      "auto": "Auto",
      "reset": "Reset to auto",
      "resetLabel": "Reset {{label}} to auto"
    }
  },
  "language_switcher": {
    "label": "Language",
    "options": {
      "en": "English",
      "es": "Español",
      "fr": "Français",
      "pt": "Português"
    }
  },
  "nav": {
    "home": "Home",
    "tenants": "Tenants",
    "newTenant": "New tenant",
    "brands": "Brands",
    "users": "Users",
    "reference": "Reference",
    "products": "Products",
    "oidcClients": "OIDC clients",
    "operators": "Operators",
    "operations": "Operations",
    "signOut": "Sign out",
    "signIn": "Sign in"
  },
  "auth": {
    "redirecting": "Redirecting to sign in…",
    "returning": "Completing sign-in…",
    "signedOutTitle": "You're signed out",
    "signedOutBody": "Your platform-admin session has ended.",
    "signInAgain": "Sign in again",
    "errorTitle": "Sign-in could not be completed",
    "errorBody": "Your session could not be restored. Try signing in again.",
    "errorReference": "Reference: {{code}}",
    "error": {
      "operatorNotRecognized": "This account isn't recognized as a platform operator.",
      "operatorDirectoryRejected": "Your organization's directory declined the sign-in.",
      "invalidOauthState": "The sign-in request expired or was invalid. Please start again.",
      "providerNotAllowed": "This sign-in provider isn't permitted for the console.",
      "oauthTenantMismatch": "This sign-in was issued for a different application.",
      "oauthFailed": "Sign-in could not be completed. Please try again."
    },
    "tryAgain": "Try again",
    "sessionExpired": {
      "redirecting": "Redirecting to sign in… ({{seconds}})",
      "signInNow": "Sign in now"
    }
  },
  "operator": {
    "menuTitle": "Account",
    "role": {
      "SAAS_ADMIN": "Admin",
      "SUPER_ADMIN": "Super admin"
    }
  },
  "tenants": {
    "list": {
      "title": "Tenants",
      "subtitle": "Customer organizations on the platform",
      "create": "Create tenant",
      "newTenantWizard": "New-tenant wizard",
      "empty": "No tenants yet. Create your first tenant to start.",
      "noMatch": "No tenants match your filters.",
      "allGroups": "All tenants",
      "columns": {
        "name": "Name",
        "slug": "Slug",
        "status": "Status",
        "signupMode": "Signup",
        "product": "Product",
        "brand": "Brand",
        "createdAt": "Created"
      },
      "filters": {
        "status": "Status",
        "signupMode": "Signup mode",
        "product": "Product",
        "brandAssigned": "Brand",
        "withoutBrand": "Without brand",
        "withBrand": "With brand",
        "all": "All",
        "allGroups": "All"
      },
      "savedViews": {
        "active": "Active customers",
        "suspended": "Suspended",
        "withoutBrand": "Without brand"
      },
      "group": {
        "columnName": "Group",
        "columnCount": "Tenants",
        "count": "{{count}} tenants",
        "back": "Back to groups",
        "empty": "No tenants in this group yet.",
        "emptyGroups": "No product groups yet."
      }
    },
    "create": {
      "title": "Create tenant",
      "submit": "Create",
      "slug": "Slug",
      "slugHelper": "Lowercase letters, digits, hyphens. This can't be changed later.",
      "name": "Name",
      "signupMode": "Signup mode",
      "product": "Product",
      "productHelper": "Optional — you can set this later.",
      "openWizard": "Use guided wizard instead"
    },
    "overview": {
      "title": "Overview",
      "warnings": {
        "noProduct": "This tenant has no product. Assign a product before attaching a brand.",
        "noAppHostname": "This tenant has no APP hostname. Users can't log in until one is registered.",
        "noAppHostnameSelfContained": "This tenant has no APP hostname. A self-contained product is reachable only through its APP host — register one.",
        "noMembers": "No members yet. Add one to give people access."
      },
      "cards": {
        "settings": "Settings",
        "urls": "URLs",
        "owners": "Owners & Admins",
        "invited": "Invited"
      },
      "hostnames": {
        "manage": "Manage",
        "colUrl": "URL",
        "colDns": "DNS",
        "dnsPending": "Pending"
      },
      "hostnamesReduced": {
        "both": "This product is self-contained and externally authenticated, so it does not use platform brand, asset, login or auth hosts.",
        "selfContained": "This product is self-contained, so it does not use platform brand or asset hosts.",
        "external": "This product is externally authenticated, so it does not use platform login or auth hosts."
      },
      "brandingNotApplicable": "Does not apply — self-contained",
      "inheritsBrand": "Inherits product default",
      "owners": {
        "empty": "No owners or admins yet."
      },
      "invited": {
        "empty": "No pending invitations."
      }
    },
    "support": {
      "action": "Open as support",
      "title": "Open as support",
      "helper": "Enter this tenant's app as platform support — you remain yourself, with platform access; this is audited.",
      "app": "App",
      "reason": "Reason",
      "open": "Open",
      "noApp": "No app hostname configured for this tenant.",
      "popupBlocked": "Allow pop-ups and try again.",
      "opened": "Support session open until {{until}}.",
      "tenantInactive": "This tenant is not active."
    },
    "fields": {
      "name": "Name",
      "slug": "Slug",
      "signupMode": "Signup mode",
      "brand": "Brand"
    },
    "tabs": {
      "overview": "Overview",
      "whitelabel": "Whitelabel",
      "branding": "Branding",
      "members": "Members",
      "invitations": "Invitations",
      "emailTemplates": "Email templates",
      "integrationSettings": "Integration Settings",
      "settings": "Settings",
      "oidc": "Connected Apps (OIDC)",
      "microsoftSso": "Microsoft SSO"
    },
    "status": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "SUSPENDED": "Suspended"
    },
    "signupMode": {
      "PUBLIC": "Public signup",
      "INVITE_ONLY": "Invite only",
      "ADMIN_CREATED_ONLY": "Admin-created only",
      "DISABLED": "Signup disabled"
    },
    "actions": {
      "suspend": "Suspend",
      "restore": "Restore",
      "inactivate": "Inactivate",
      "reactivate": "Reactivate",
      "reassignProduct": "Reassign product",
      "editSettings": "Edit settings"
    },
    "confirm": {
      "suspendTitle": "Suspend tenant?",
      "suspendBody": "Suspending {{name}} will block all logins for this tenant immediately. Active sessions will sign out on next refresh. You can restore the tenant later.",
      "restoreTitle": "Restore tenant?",
      "restoreBody": "Restoring {{name}} will allow logins again.",
      "inactivateTitle": "Inactivate tenant?",
      "inactivateBody": "Inactivating {{name}} blocks all logins; treat as ended. You can reactivate later."
    },
    "settings": {
      "title": "Settings",
      "name": "Name",
      "slug": "Slug",
      "slugHelper": "Stable URL identifier — cannot be changed once created.",
      "signupMode": "Signup mode",
      "emailTemplatesDir": "Email templates directory",
      "emailFromName": "Email from name",
      "emailFromAddress": "Email from address",
      "emailSupportEmail": "Support email",
      "platformPlaceholder": "platform default: {{value}}",
      "emailFromCaveat": "A custom From domain must be authenticated with the mail provider (SPF/DKIM) or recipients' DMARC will junk the mail — operator responsibility.",
      "localeSection": "Localization",
      "localeNotice": "Tenant default locale and switch policy are configured via SQL today. Contact ops to change."
    }
  },
  "hostnames": {
    "title": "Hostnames",
    "summary": {
      "title": "This tenant’s URLs",
      "help": "Every hostname this tenant is reachable on. System URLs are provisioned by the platform; white-label URLs come from the tenant’s white-label domain.",
      "dnsCopy": "Copy DNS instructions",
      "dnsCopied": "DNS instructions copied.",
      "dnsNoDomain": "This tenant has no white-label domain — nothing for the customer to publish.",
      "dnsNoTarget": "The platform DNS target isn’t available, so instructions would be incomplete.",
      "columns": {
        "systemUrl": "System URL",
        "systemDns": "System DNS",
        "whitelabelUrl": "Whitelabel URL",
        "whitelabelDns": "Whitelabel DNS"
      }
    },
    "whitelabel": {
      "title": "Whitelabel"
    },
    "wl": {
      "title": "White-label domain",
      "loadError": "Couldn't load the white-label domain.",
      "none": "This tenant has no white-label domain. Its users reach it on the system URLs below.",
      "setUp": "Set up white-label domain",
      "unassigned": "unassigned",
      "state": {
        "draft": "Draft — not live until every host verifies",
        "active": "Active since {{date}}",
        "activeNoDate": "Active"
      },
      "verify": "Verify DNS",
      "edit": "Edit",
      "remove": "Remove white-label domain",
      "removeTitle": "Remove white-label domain?",
      "removeBody": "This deletes {{domain}} and its {{count}} hostnames. Customers will no longer reach this tenant on them.",
      "removed": "White-label domain removed.",
      "verifyPartial": "Not verified yet: {{hosts}}. Check the DNS records below — DNS changes can take a while to propagate — then verify again.",
      "verifiedAllDeploy": "All hosts verified — the domain is active. Deploy this tenant's routing to put the white-label URLs live.",
      "deployNow": "Deploy this tenant's routing",
      "dnsTitle": "DNS records the customer must create",
      "colHost": "Host",
      "colType": "Type",
      "colTarget": "Target",
      "colStatus": "Status",
      "verified": "Verified",
      "notVerified": "Not verified",
      "domainLabel": "Domain",
      "domainHelper": "The customer's own domain, e.g. example.com — not the platform's or a product's domain.",
      "hostsTitle": "Hosts on this domain",
      "colInclude": "Include",
      "colSurface": "Surface",
      "colPrefix": "Prefix",
      "colHostname": "Hostname",
      "includeAria": "Include {{surface}}",
      "prefixAria": "Prefix for {{surface}}",
      "tooMany": "A white-label domain can have at most 10 hosts.",
      "saved": "White-label domain saved. Verify DNS once the customer has created the records.",
      "replaceTitle": "Replace the white-label hosts?",
      "replaceBody": "Saving re-creates every white-label host unverified and puts the domain back in Draft. Its white-label URLs stop working until DNS verifies again and routing is redeployed.",
      "replaceConfirm": "Save and re-verify",
      "retry": "Retry",
      "draftHelp": "Hosts go live when every host verifies.",
      "liveAuto": "White-label domain is live. Routing was deployed automatically."
    },
    "custom": {
      "open": "Custom hostname for {{app}}",
      "chip": "Custom",
      "alsoWl": "Also: {{url}}",
      "checkDns": "Check DNS",
      "title": "Custom hostname — {{app}}",
      "current": "Currently served at",
      "help": "Serve this app on a hostname from another domain, e.g. a marketing site at www.example.ai, while sign-in stays on the white-label domain. It needs its own CNAME and DNS check. Pages on another domain can link to sign-in but can't silently tell who is signed in.",
      "field": "Hostname",
      "onWlDomain": "That's on the white-label domain — set it in the White-label domain panel above.",
      "isSystem": "That's one of this tenant's system URLs.",
      "cname": "Create a CNAME: {{host}} → {{target}}",
      "dnsNotConfigured": "DNS checking isn't configured on saas-auth (an ops task).",
      "dnsPending": "DNS not found yet. It can take a few minutes after you create the CNAME.",
      "revert": "Revert to white-label domain",
      "revertConfirm": "Remove {{host}}? The app stays on its white-label URL.",
      "revertConfirmAction": "Confirm",
      "taken": "That hostname is already used by a tenant.",
      "added": "Added. Create the CNAME, then press Check DNS.",
      "addedDeploy": "Added. Create the CNAME, then press Check DNS — it puts the hostname live.",
      "verifiedDeployed": "DNS verified — routing deployed. The hostname is live.",
      "reverted": "Reverted to the white-label URL.",
      "oldKept": "The new hostname was added, but {{old}} couldn't be removed. Remove it under Other hostnames."
    },
    "other": {
      "title": "Other hostnames",
      "help": "Extra hostnames for this tenant on another domain, e.g. a marketing site at www.example.ai while the apps and sign-in stay on the white-label domain. Each one needs its own CNAME and DNS check. They aren't part of the white-label domain's daily re-check. Pages on another domain can link to sign-in, but can't silently tell who is signed in (browsers block that cookie across domains).",
      "colApp": "App",
      "colDns": "DNS",
      "changeApp": "Change app for {{hostname}}",
      "remove": "Remove {{hostname}}",
      "onlyApp": "This is the tenant's only app hostname.",
      "add": "Add hostname",
      "empty": "No other hostnames."
    },
    "redirect": {
      "action": "Redirect to",
      "aria": "Redirect {{host}} to",
      "none": "No redirect",
      "chip": "Redirect",
      "set": "Redirect set.",
      "cleared": "Redirect removed.",
      "hint": "Redirect: visitors to a hostname are sent to its target, keeping the path. Use it for www → bare domain. A bare domain needs CNAME flattening or an A record at your DNS provider.",
      "needsNewerAuth": "Redirects appear once saas-auth is updated.",
      "sources": "Redirecting here: {{list}} — change them under Other hostnames."
    },
    "pinned": {
      "chip": "Pinned",
      "tooltip": "Pointed at this app by an operator — Make primary won't move it. Point it at the primary app to unpin."
    },
    "add": {
      "title": "Add hostname",
      "appRequired": "Choose an app.",
      "redirectHelper": "Optional. The new hostname must pass Check DNS before the redirect is served.",
      "redirectFailed": "Added {{host}}, but the redirect wasn't set: {{message}}. Set it from Other hostnames.",
      "added": "Added. Create the CNAME, then press Check DNS — it puts the hostname live."
    },
    "clear": {
      "confirmTitle": "Remove custom hostname?",
      "confirmBody": "This removes {{hostname}} — the customer will no longer reach this tenant at that address.",
      "confirmAction": "Clear"
    },
    "type": "Type",
    "hostname": "Hostname",
    "createdAt": "Created",
    "empty": "No hostnames yet. Register an APP host so users can log in.",
    "emptySelfContained": "No hostnames yet. A self-contained product is reachable through a single URL you register — add a custom domain to get started.",
    "addCustomDomain": "Add custom domain",
    "app": {
      "assigned": "App: {{slug}}",
      "field": "App",
      "emptyPortfolio": "This product has no apps yet. This hostname will not be served until an app exists and is assigned.",
      "emptyPortfolioLink": "Manage this product's apps",
      "explain": "An app is one deployable frontend (its own Caddy docroot); APP hostnames route to one app of the product."
    },
    "verified": "DNS verified",
    "verifiedOn": "Verified {{date}}",
    "dns": {
      "check": "Check DNS",
      "matched": "DNS verified",
      "waiting": "Not resolving to the expected target yet — DNS can take a while to propagate. Last checked {{checkedAt}}.",
      "resolved": "Resolves to: {{ips}}",
      "notConfigured": "The platform has no expected DNS target configured yet (a saas-auth ops task).",
      "resolutionError": "Verification system problem — not your DNS record. Try again shortly.",
      "expectedResolved": "The platform's expected target couldn't be resolved — a platform-side issue. Contact ops."
    },
    "types": {
      "APP": "App",
      "SELF_CONTAINED": "Self-contained",
      "LOGIN": "Login",
      "AUTH": "Auth",
      "API": "API",
      "ASSET": "Asset",
      "BRAND": "Brand"
    },
    "backfill": {
      "button": "Backfill Hostnames (All Tenants)",
      "confirmTitle": "Backfill default hostnames?",
      "confirmBody": "This provisions any missing default hostnames (login, auth, brand, asset) for ALL tenants in this environment. It is idempotent and additive — existing hostnames are left exactly as they are.",
      "confirmSessions": "When a tenant gains a login host, its session cookie moves to the tenant apex, so users of affected tenants are signed out once — including you, if you hold a session on one.",
      "confirmAction": "Run backfill",
      "doneSnack": "Default hostnames backfilled.",
      "done": "Backfill complete — {{processed}} tenants processed, {{created}} hostnames created, {{existing}} already present, {{skipped}} tenants skipped.",
      "truncated": "NOT finished — tenants remain unprovisioned. {{processed}} tenants processed and {{created}} hostnames created so far. Choose Continue to resume.",
      "continue": "Continue",
      "notConfigured": "Nothing ran — the platform base domain is not configured in this environment. No hostnames were created. This is an environment configuration problem: set the tenant base domain, then run the backfill again.",
      "stoppedEarly": "The run stopped early after an error. The counts below cover only the tenants processed before it stopped.",
      "skippedIntro": "Skipped, with reasons — this is normal, not a failure. A tenant with no presence on the platform base domain is deliberately skipped, because minting platform hosts for it would break its session cookie:",
      "deployRequired": "Not serving yet — {{created}} hostname rows were created in the database, but routing has not been deployed. Until you deploy platform routing, nothing serves these hosts."
    }
  },
  "routing": {
    "deploy": {
      "button": "Deploy Platform Routing",
      "unavailable": "Routing deploy isn't available yet.",
      "notReadyTooltip": "Some hostnames below are still pending; they won't be served until resolved.",
      "blockingIntro": "Pending before this tenant is go-live ready:",
      "reasonDnsNotVerified": "DNS not verified",
      "reasonNoApp": "No app assigned",
      "doneGlobalSnack": "Routing deployed.",
      "doneGlobal": "Routing deployed — {{tenants}} tenants, {{written}} fragments written, {{removed}} removed.",
      "reloaded": "Caddy reloaded.",
      "reloadSkipped": "Caddy reload skipped.",
      "tenantButton": "Deploy this Tenant Routing",
      "doneTenantSnack": "Tenant routing deployed.",
      "doneTenant": "Deployed this tenant — wrote {{file}}.",
      "doneTenantRemoved": "Deployed this tenant — no routable hosts, fragment removed."
    }
  },
  "routingDeploy": {
    "failedTitle": "Saved, but the routing deploy didn't apply",
    "failedNoMessage": "The edge did not accept the new routing.",
    "failedHelp": "The change is saved. Sites keep serving the last routing that applied. Fix the cause, then deploy routing again.",
    "openOperations": "Open Operations to deploy routing",
    "deployTenant": "Deploy this tenant's routing",
    "partialTitle": "Routing deployed, but some settings were kept on their previous version",
    "partialThisTenant": "Your change to this tenant didn't apply.",
    "partialBody": "These were kept on their previous version because their settings couldn't be applied:",
    "partialHelp": "Fix their settings, then deploy again.",
    "partialSnack": "Routing deployed, but some settings were kept on their previous version: {{list}}. Fix their settings, then deploy again.",
    "heldBackConflict": "Routing not deployed: {{heldBack}} couldn't be applied, and its previous routing still claims {{host}}, which now belongs to {{owner}}. Fix {{heldBack}}'s settings, then deploy.",
    "ownerTenant": "tenant #{{id}}",
    "ownerProduct": "product #{{id}}"
  },
  "appBuilds": {
    "title": "App builds",
    "help": "Serve this tenant a customized build of its public app, or turn the public app off for this tenant. It is the same app — sign-in, roles, API and hosts don't change; only what Caddy serves for this tenant does.",
    "unavailable": "Custom builds aren't available yet (saas-auth SASATH-0387 not deployed).",
    "loadError": "Couldn't load app builds.",
    "empty": "This product has no public app.",
    "colApp": "App",
    "colEnabled": "Enabled",
    "colServingFrom": "Serving from",
    "custom": "Custom",
    "default": "Default",
    "set": "Set custom build",
    "change": "Change",
    "revert": "Revert to default",
    "dialogTitle": "Custom build for {{app}}",
    "folderLabel": "Build folder on the edge",
    "confirm": "Deploy the custom build to this folder first. Until it has an index.html, this tenant's site shows 404.",
    "save": "Save",
    "revertTitle": "Revert {{app}} to the default build?",
    "revertBody": "This tenant will be served {{folder}} again.",
    "revertStillOff": "This does not turn the app back on.",
    "savedDeployed": "Custom build set. Routing deployed.",
    "revertedDeployed": "Reverted to the default build. Routing deployed.",
    "queued": "Saved. Routing deploy queued.",
    "skipped": "Saved. Routing deploy skipped: {{message}}",
    "saved": "Saved.",
    "reverted": "Reverted to the default build.",
    "enabledAria": "Enabled: {{app}}",
    "disableTitle": "Turn off {{app}} for {{tenant}}?",
    "disableBody": "Its customers can't sign in, stay signed in, or sign up until you turn it back on. Staff, admins and affiliates are unaffected. The public site shows the offline page below, or \"This site is currently unavailable.\"",
    "disableConfirm": "Turn off",
    "disabledDeployed": "{{app}} is off for this tenant. Routing deployed.",
    "enabledDeployed": "{{app}} is back on. Routing deployed.",
    "disabled": "{{app}} is off for this tenant.",
    "enabled": "{{app}} is back on.",
    "colOfflinePage": "Offline page",
    "offlineIdle": "Used only while the app is off",
    "offlineSet": "Set offline page",
    "offlineChange": "Change offline page",
    "offlineClear": "Clear offline page",
    "offlineClearConfirm": "Clear the offline page? While the app is off, visitors will see a plain 'unavailable' message.",
    "offlineDialogTitle": "Offline page for {{app}}",
    "offlineField": "Offline page folder on the edge",
    "offlineConfirm": "Deploy the static site to this folder first.",
    "offlineHint": "Shown only while the app is off. Without one, visitors see a plain 'unavailable' message.",
    "offlineSaved": "Offline page set.",
    "offlineSavedDeployed": "Offline page set. Routing deployed.",
    "offlineCleared": "Offline page cleared.",
    "offlineClearedDeployed": "Offline page cleared. Routing deployed.",
    "affiliateEnabled": "{{app}} is enabled for this tenant.",
    "affiliateEnabledDeployed": "{{app}} is enabled for this tenant. Routing deployed.",
    "affiliateDisableBody": "Its affiliate host stops serving for this tenant. Customers, staff and the public app are unaffected. Turning it back on restores it.",
    "affiliateDisabled": "{{app}} is off for this tenant.",
    "affiliateDisabledDeployed": "{{app}} is off for this tenant. Routing deployed.",
    "affectedTenants": "Tenants:"
  },
  "operations": {
    "title": "Platform Operations",
    "intro": "Actions that affect every tenant in this environment.",
    "backfillSection": "Provision missing default hostnames (login, auth, brand, asset) for every tenant in this environment.",
    "deploySection": "Regenerate and reload Caddy routing for every tenant from the database. This is idempotent and safe to run at any time."
  },
  "members": {
    "title": "Members",
    "add": "Add member",
    "email": "Email",
    "role": "Role",
    "status": "Status",
    "createdAt": "Added",
    "ssoAccess": "GHL/SSO access",
    "ssoHelper": "Per-membership SSO/GHL access — not a role. On by default; active members of an allow-listed OIDC client can sign in via SSO.",
    "empty": "No members yet. Add one to give people access.",
    "lastOwnerWarning": "This is the only Owner. Demote with care.",
    "addHelper": "Adds someone who already has an account. For Microsoft sign-in, use Invitations.",
    "entraTooltip": "Microsoft account. The username shown is from Microsoft and is for display only.",
    "actions": {
      "changeRole": "Change role",
      "disable": "Disable",
      "enable": "Enable",
      "remove": "Remove from tenant"
    },
    "confirm": {
      "disableTitle": "Disable member?",
      "disableBody": "{{email}} will not be able to log in to {{tenant}} until you re-enable them. Other tenants are unaffected.",
      "enableTitle": "Enable member?",
      "enableBody": "{{email}} will be able to log in to {{tenant}} again.",
      "removeTitle": "Remove member?",
      "removeBody": "Remove {{email}} from {{tenant}}? They'll keep their account but lose access to this tenant."
    },
    "roles": {
      "OWNER": "Owner",
      "SUPER_ADMIN": "Super admin",
      "ADMIN": "Admin",
      "STAFF": "Staff",
      "USER": "User",
      "GUEST": "Guest",
      "EMPLOYEE": "Employee"
    },
    "statuses": {
      "ACTIVE": "Active",
      "INVITED": "Invited",
      "DISABLED": "Disabled"
    }
  },
  "invitations": {
    "title": "Invitations",
    "invite": "Invite",
    "dialogTitle": "Invite a person",
    "email": "Email",
    "role": "Role",
    "oidcClients": "OIDC access",
    "oidcClientsHelper": "Grant the new member SSO access to these OIDC clients on accept. Optional — leave all unchecked for no OIDC access.",
    "noOidcClients": "This tenant isn't allow-listed on any OIDC client.",
    "noOidcAccess": "No OIDC access",
    "groups": {
      "employee": "Employee app",
      "admin": "Admin app"
    },
    "hintLine": "Addresses on {{domain}} are pre-authorized (no email). Others receive an invitation email.",
    "sentPreAuthorized": "Pre-authorized. {{email}} gets access on their first Microsoft sign-in. No email was sent.",
    "preAuthorized": "Pre-authorized",
    "preAuthorizedTooltip": "Activates on first Microsoft sign-in · expires 30 days after creation",
    "empty": "No invitations yet. Invite someone to join this tenant.",
    "columns": {
      "email": "Email",
      "role": "Role",
      "oidcClients": "OIDC access",
      "status": "Status",
      "invited": "Invited",
      "expires": "Expires"
    },
    "errors": {
      "OIDC_CLIENT_NOT_ALLOWED_FOR_TENANT": "One or more selected OIDC clients no longer allow-list this tenant. Reopen and try again."
    },
    "filter": {
      "all": "All",
      "pending": "Pending",
      "accepted": "Accepted"
    },
    "statuses": {
      "PENDING": "Pending",
      "ACCEPTED": "Accepted",
      "REVOKED": "Revoked",
      "EXPIRED": "Expired"
    },
    "actions": {
      "revoke": "Revoke"
    },
    "confirm": {
      "revokeTitle": "Revoke invitation?",
      "revokeBody": "Revoke the invitation for {{email}}? The invite link will stop working."
    }
  },
  "emailTemplates": {
    "configTitle": "Email configuration",
    "title": "Email templates",
    "slot": "Slot",
    "filename": "File name",
    "platformDefault": "Platform default",
    "noDirHint": "This tenant has no email-template directory configured. Set it on the Settings tab first, otherwise mappings will not resolve.",
    "fileMustExist": "This file must exist at <tenant.emailTemplatesDir>/<filename> on the server (deployed by ops, not uploaded here).",
    "upsertTitle": "Map template",
    "deleteTitle": "Revert to default?",
    "deleteBody": "Future emails for {{slot}} will use the platform's standard template.",
    "names": {
      "EMAIL_VERIFICATION": "Email verification",
      "PASSWORD_RESET": "Password reset",
      "GOOGLE_SIGNIN_NOTICE": "Google sign-in notice",
      "MFA_CODE": "MFA code",
      "TENANT_INVITATION": "Tenant invitation"
    }
  },
  "branding": {
    "title": "Branding",
    "current": "Current brand",
    "inherits": "Inherits product default",
    "assignDifferent": "Assign a different brand",
    "clear": "Clear brand (inherit default)",
    "editThis": "Edit this brand",
    "noProduct": "Assign a product before configuring branding.",
    "selfContainedNotApplicable": "Branding does not apply to a self-contained product — it serves its own UI and assets.",
    "pickerTitle": "Pick a brand",
    "pickerEmpty": "No brands for this product yet."
  },
  "brands": {
    "list": {
      "title": "Brands",
      "subtitle": "Product-scoped visual identities (shared across tenants)",
      "create": "Create brand",
      "empty": "No brands yet."
    },
    "editor": {
      "newTitle": "New brand",
      "identity": "Identity",
      "appearance": "Appearance",
      "brandImages": "Brand images",
      "authProviders": "Auth providers",
      "copyAndProviders": "Copy & providers",
      "copyAndProvidersHint": "Login title, welcome headline, product short name, tagline, location and hero copy are edited in the Login template & marketing section.",
      "reservedKeyHelper": "Managed in the Login template & marketing section above.",
      "unusedFields": "Not used by this template",
      "heroNotUsed": "Not used by the {template} template",
      "tenantsUsing": "Tenants using this brand",
      "tenantsUsingTruncated": "Showing first {{n}} of {{total}}.",
      "preview": "Preview",
      "loginTemplateMarketing": "Login template & marketing",
      "delete": "Delete brand",
      "deleteBody": "Delete {{name}}? This cannot be undone.",
      "deleteBlocked": "Cannot delete — this brand is currently in use.",
      "isProductDefault": "This brand is the default for {{product}}.",
      "tenantsBlocking": "Reassign these tenants first:"
    },
    "tabs": {
      "preview": "Preview",
      "theme": "Theme",
      "translations": "Translations",
      "advanced": "Advanced"
    },
    "assetSlots": {
      "title": "More brand images",
      "loading": "Loading brand images",
      "loadFailed": "Couldn't load the brand images.",
      "reload": "Reload",
      "notSet": "Not set",
      "lightTile": "{{label}} on a light background",
      "darkTile": "{{label}} on a dark background",
      "replace": "Replace",
      "replaceLabel": "Replace {{label}}",
      "clear": "Clear",
      "clearLabel": "Clear {{label}}",
      "clearTitle": "Clear {{label}}?",
      "clearBody": "The {{label}} image is removed from this brand. Apps fall back to their default.",
      "uploading": "Uploading…",
      "tooLarge": "File is over 5 MB.",
      "rateLimited": "Too many requests — try again in {{n}} s",
      "safeZone": "Maskable safe zone",
      "groups": {
        "marks": "Marks",
        "appIcons": "App icons",
        "onboarding": "Onboarding",
        "marketing": "Marketing"
      },
      "slots": {
        "logoReversed": "Reversed logo",
        "mark": "Mark",
        "faviconSvg": "SVG favicon",
        "appleTouchIcon": "Apple touch icon",
        "maskableIcon": "Maskable icon",
        "onboardingLight": "Onboarding (light)",
        "onboardingDark": "Onboarding (dark)",
        "emailHeader": "Email header",
        "socialImage": "Social image"
      },
      "rules": {
        "logoReversed": "SVG or PNG. PNG at least 480×128, transparent.",
        "mark": "SVG or PNG, square. PNG at least 256×256, transparent.",
        "faviconSvg": "SVG with a square viewBox.",
        "appleTouchIcon": "PNG, exactly 180×180, opaque.",
        "maskableIcon": "PNG, exactly 512×512. Keep the artwork inside the circle.",
        "onboardingLight": "SVG or PNG, at most 2400 px on the long side.",
        "onboardingDark": "SVG or PNG, at most 2400 px on the long side.",
        "emailHeader": "PNG, exactly 600×120.",
        "socialImage": "PNG or JPEG, exactly 1200×630."
      }
    },
    "bundle": {
      "export": "Export bundle",
      "import": "Import bundle",
      "exportRateLimited": "Too many exports — try again in {{n}} s",
      "title": "Import bundle",
      "intro": "Upload a bundle exported from a brand. It is checked first; nothing changes until you apply it.",
      "chooseFile": "Choose file",
      "flatZipHint": "Zip the bundle's files themselves — manifest.json, theme.json, copy.json, assets/ — not the folder that contains them. On a Mac, don't use Finder's Compress; the bundle's README has the zip command.",
      "reexportNote": "Bundles exported before 12 Oct 2026 (theme engine 6) can't be imported to the same brand. Export again first.",
      "folderZip": "This zip contains a folder (or macOS extras) instead of the bundle files at the top level. Re-zip the files themselves and choose it again.",
      "dsStore": "This zip includes macOS .DS_Store files. Remove them and re-zip — the bundle's README (Zip the files, not their folder) has the command.",
      "details": "Details",
      "chooseAnother": "Choose another file",
      "noFile": "No file chosen",
      "tooLarge": "This bundle is over 10 MB",
      "check": "Check bundle",
      "apply": "Apply",
      "close": "Close",
      "applied": "Bundle applied",
      "rateLimited": "Too many bundle checks — try again in {{n}} s",
      "statusReady": "Ready to apply",
      "statusBlocked": "Can't apply",
      "reasonErrors": "The bundle has errors — see Errors below.",
      "reasonContrast": "A colour in this bundle fails WCAG AA contrast.",
      "etagChanged": "This brand changed since the bundle was exported — export again.",
      "otherBrand": "This bundle was exported from another brand.",
      "applyInvalid": "The bundle has errors. Nothing was applied.",
      "applyContrast": "A colour in this bundle fails WCAG AA contrast. Nothing was applied.",
      "changes": "Changes",
      "theme": "Theme",
      "copyDefault": "Default text",
      "copyLocale": "Translations ({{locale}})",
      "assets": "Images",
      "added": "Added",
      "replaced": "Replaced",
      "cleared": "Cleared",
      "unchanged": "Unchanged",
      "noChanges": "No changes",
      "warnings": "Warnings",
      "contrast": "Contrast",
      "contrastOk": "All text meets WCAG AA",
      "errors": "Errors",
      "wholeBundle": "Whole bundle"
    },
    "translations": {
      "saveBrandFirst": "Save the brand first.",
      "loading": "Loading translations",
      "loadFailed": "Couldn't load the translations.",
      "reload": "Reload",
      "title": "Translations",
      "hint": "Blank cells use the default text. Default text is edited in the Advanced tab.",
      "key": "Text",
      "defaultColumn": "Default ({{locale}})",
      "noDefault": "Not set",
      "missing": "{{n}} missing",
      "cellLabel": "{{key}} ({{locale}})",
      "tooLong": "At most {{n}} characters.",
      "save": "Save translations",
      "saved": "Translations saved.",
      "unsaved": "Unsaved translation changes",
      "rateLimited": "Too many saves — try again in {{n}} s",
      "keys": {
        "productName": "Product name",
        "productShortName": "Product short name",
        "loginTitle": "Login title",
        "tagline": "Tagline",
        "heroCopy": "Hero copy",
        "location": "Location",
        "welcomeHeadline": "Welcome headline",
        "supportEmail": "Support email"
      },
      "locales": {
        "es": "Spanish (es)",
        "fr": "French (fr)",
        "pt": "Portuguese (pt)"
      }
    },
    "theme": {
      "saveBrandFirst": "Save the brand first.",
      "loading": "Loading theme",
      "loadFailed": "Couldn't load the theme.",
      "reload": "Reload",
      "usedBy": "Used by {{n}} tenants — theme changes apply to all of them.",
      "brandColours": "Brand colours",
      "brandRamp": "Brand shades",
      "accentRamp": "Accent shades",
      "seeds": {
        "primary": "Primary",
        "accent": "Accent",
        "neutral": "Neutral",
        "success": "Success",
        "warning": "Warning",
        "error": "Error",
        "info": "Info",
        "moneyPositive": "Positive money",
        "moneyNegative": "Negative money"
      },
      "surfaces": "Surfaces",
      "surfaceTinted": "Tinted",
      "surfacePure": "Pure",
      "neutralPure": "Pure surfaces are grey — the neutral seed is not used.",
      "shape": "Shape",
      "cornerSharp": "Sharp",
      "cornerRounded": "Rounded",
      "cornerPill": "Pill",
      "cornerCustom": "Custom radius — pick a style to replace it",
      "sampleButton": "Button",
      "typography": "Typography",
      "fonts": {
        "body": "Body",
        "heading": "Heading",
        "mono": "Mono",
        "sourceLabel": "{{slot}} font source",
        "google": "Google",
        "system": "System",
        "familyLabel": "{{slot}} font",
        "systemInvalid": "Up to 100 letters, digits, spaces and hyphens."
      },
      "advanced": "Advanced",
      "seedsSection": "Neutral, status & money",
      "status": "Status",
      "money": "Money",
      "categorical": "Categorical",
      "categoricalSlot": "Category {{n}}",
      "overrides": "Overrides",
      "overridesHint": "Each cell shows the resolved value. Setting one pins it; Reset clears it.",
      "overrideCell": "{{mode}} {{role}}",
      "overrideGroup": "Role group",
      "overrideGroups": {
        "canvas": "Canvas",
        "text": "Text",
        "lines": "Lines & focus",
        "brand": "Brand",
        "accent": "Accent",
        "appBar": "App bar",
        "success": "Success",
        "warning": "Warning",
        "error": "Error",
        "info": "Info",
        "money": "Money",
        "highlight": "Highlight"
      },
      "role": "Role",
      "previewRateLimited": "Too many preview requests — edit again in a moment.",
      "contrast": {
        "title": "Contrast",
        "ok": "All text meets WCAG AA",
        "row": "{{mode}} · {{fg}} on {{bg}} · {{ratio}} : 1 (needs {{required}})",
        "blocking": "Blocks save",
        "existing": "Existing — does not block"
      },
      "save": {
        "button": "Save theme",
        "changed": "This theme changed elsewhere — reload",
        "contrastFailed": "A changed colour fails WCAG AA contrast. Nothing was saved.",
        "rateLimited": "Too many saves — try again in {{n}} s"
      },
      "unsaved": "Unsaved theme changes",
      "editInThemeTab": "Edit colours in the Theme tab",
      "openThemeTab": "Open the Theme tab",
      "appearanceMoved": "Colours and fonts are edited in the Theme tab.",
      "preview": {
        "title": "Live preview",
        "light": "Light",
        "dark": "Dark",
        "paneLabel": "{{mode}} preview",
        "navHome": "Home",
        "navReports": "Reports",
        "tab": "Tab",
        "cardTitle": "Welcome back",
        "cardBody": "Your bookings are up to date.",
        "cardSecondary": "Last synced 2 minutes ago",
        "link": "View details",
        "primaryButton": "Primary",
        "accentButton": "Accent",
        "inputPlaceholder": "Search…",
        "inputFocused": "Focused",
        "chart": "Sample bar chart",
        "alerts": {
          "success": "Saved",
          "warning": "Check this",
          "error": "Failed",
          "info": "Heads up"
        }
      }
    },
    "slots": {
      "heroImage": "Hero image",
      "logo": "Logo",
      "favicon": "Favicon",
      "heading": "Login title",
      "subtitle": "Short name",
      "tagline": "Tagline",
      "heroCopy": "Hero copy",
      "location": "Location",
      "signInButton": "Sign-in button",
      "pageBackground": "Page background",
      "cardBorder": "Card border",
      "googleButton": "Google sign-in",
      "signupLink": "Sign-up link",
      "forgotPassword": "Password reset link",
      "guestSignup": "Guest signup",
      "headingCurrentlyShowing": "Currently showing: {{value}}"
    },
    "preview": {
      "noConfig": "No preview config found. Open this from the Brand Editor.",
      "banner": "Preview — not a working login",
      "subtitle": "Sign in to your {{brand}} account",
      "email": "Email",
      "password": "Password",
      "rememberMe": "Remember me",
      "signIn": "Sign in",
      "continueWithGoogle": "Continue with Google",
      "forgotPassword": "Forgot password?",
      "signUp": "Sign up",
      "guestSignup": "Continue as guest",
      "zoom": "Zoom",
      "fit": "Fit",
      "fullSize": "100%"
    },
    "guestSignup": {
      "defaultLabel": "Continue as guest",
      "effective": "Links to {{url}} — shown as “{{label}}”.",
      "unset": "Set the guest URL on the product"
    },
    "fields": {
      "product": "Product",
      "slug": "Slug",
      "displayName": "Display name",
      "colorsText": "Text",
      "authProviders": "Auth providers",
      "signupEnabled": "Signup enabled",
      "passwordResetEnabled": "Password reset enabled",
      "template": "Login template",
      "templateHelper": "Absent → centered (default)",
      "templateDefault": "Default (centered)",
      "shortName": "Product short name",
      "shortNameHelper": "Used in the app bar, tab title, and installed-app name.",
      "loginTitle": "Login title",
      "welcomeHeadline": "Welcome headline",
      "tagline": "Tagline",
      "heroCopy": "Hero copy",
      "location": "Location",
      "guestSignupEnabled": "Show 'Continue as guest' link on the login page",
      "logoImage": "Logo",
      "faviconImage": "Favicon",
      "heroImage": "Hero image",
      "logoSizeHint": "Recommended: ~480×128 px transparent PNG",
      "faviconSizeHint": "Recommended: 256×256 px square PNG (no .ico)",
      "heroSizeHint": "Recommended: 1920×1080 px (16:9) JPEG",
      "noImageYet": "No image uploaded yet",
      "uploadCreateHint": "Save the brand first, then upload an image.",
      "chooseFile": "Choose file",
      "replaceImage": "Replace image",
      "upload": "Upload",
      "uploading": "Uploading…",
      "clearImage": "Clear image",
      "useCustomUrl": "Use a custom image URL",
      "customImageUrl": "Image URL",
      "customUrlInvalid": "Must be a valid http(s) URL with a filename (e.g. https://cdn.example.com/logo.png)",
      "parsedAs": "Parsed as:",
      "servedFrom": "served from",
      "switchBackToUpload": "Switch back to upload"
    },
    "templates": {
      "centered": "Centered (default)",
      "split-hero": "Split hero",
      "backdrop": "Backdrop"
    },
    "placeholders": {
      "loginTitle": "Sign in to {short name}",
      "tagline": "Bookings made simple",
      "heroCopy": "Get started today.",
      "location": "San Francisco"
    }
  },
  "users": {
    "list": {
      "title": "Users",
      "subtitle": "Platform-wide directory (read-only)",
      "empty": "No users found.",
      "noMatch": "No users match your search.",
      "columns": {
        "name": "Name",
        "email": "Email",
        "verified": "Verified",
        "googleLinked": "Google",
        "createdAt": "Joined"
      }
    },
    "detail": {
      "memberships": "Tenant memberships",
      "noMemberships": "This user has no tenant memberships."
    }
  },
  "products": {
    "tabs": {
      "apps": "Apps",
      "ariaLabel": "Product sections",
      "internalKeys": "Internal keys",
      "limits": "Limits",
      "plans": "Plans",
      "oidc": "Connected Apps (OIDC)",
      "agents": "Agents",
      "ghlMarketplace": "GHL Marketplace"
    },
    "list": {
      "title": "Products",
      "subtitle": "Top-level platform offerings",
      "create": "New product",
      "columns": {
        "displayName": "Name",
        "slug": "Slug",
        "jwtAudience": "JWT audience",
        "defaultMfaPolicy": "MFA",
        "appTopology": "Packaging",
        "toggle": "Expand or collapse group"
      },
      "filters": {
        "group": "Group",
        "allGroups": "All groups"
      },
      "allGroups": "All products",
      "empty": "No products yet.",
      "emptyFiltered": "No products in this group.",
      "group": {
        "expand": "Expand {{group}}",
        "collapse": "Collapse {{group}}",
        "count": "{{count}} products"
      }
    },
    "editor": {
      "newTitle": "New product",
      "identity": "Identity",
      "mfaDefaults": "MFA defaults",
      "guestSignup": "Guest signup",
      "defaultBrand": "Default brand",
      "delete": "Delete product",
      "deleteBody": "Delete {{name}}? This cannot be undone."
    },
    "detail": {
      "configuration": "Configuration",
      "guestLabelDefault": "Continue as guest (default)",
      "platformLine": "Platform: {{auth}}{{login}} · mail from {{mail}}",
      "platformAuthLine": "Auth: auth.journix.ai · Login: login.journix.ai — platform services",
      "authLoginGuidance": "To brand auth/login for a customer, add an AUTH/LOGIN-type hostname on the Tenant's Hostnames tab (the customer CNAMEs it to the platform host). There is no product-level auth/login setting.",
      "tenantsTruncated": "Showing first {{n}} of {{total}}."
    },
    "apps": {
      "title": "Apps",
      "explanation": "Manage the app roles available for this product's packaging.",
      "empty": "No apps in this product yet.",
      "add": "Add app",
      "edit": "Edit app",
      "primary": "Primary",
      "setPrimary": "Make primary",
      "setPrimarySnack": "Primary app updated.",
      "clearPrimary": "Clear primary",
      "clearPrimarySnack": "Primary flag cleared.",
      "setPrimaryTitle": "Make {{name}} the primary app?",
      "setPrimaryBody": "Every tenant's main address will switch to this app. The current primary app keeps its own address on each tenant.",
      "reapplyPrimary": "Re-apply primary",
      "reapplyPrimaryHint": "Moves any tenant's main address still left on another app to this one.",
      "reapplyNothing": "Nothing to repair — every tenant's main address is already on this app.",
      "reapplyDone": "Repaired — tenants' main addresses moved to this app.",
      "reapplyPrimaryTitle": "Re-apply primary to {{name}}?",
      "apexPlan": {
        "willMove": "{{n}} tenant(s) will move to {{app}}",
        "moved": "{{n}} tenant(s) moved to {{app}}",
        "fromApp": "from {{app}}",
        "nothingMoves": "No tenant's main address will move.",
        "nothingMoved": "No tenant's main address moved.",
        "skipped": "{{n}} skipped",
        "reasons": {
          "PINNED": "pointed at another app by an operator",
          "PRIMARY_APP_DISABLED": "this app is disabled for the tenant",
          "SELF_CONTAINED_PRIMARY": "SELF_CONTAINED_PRIMARY",
          "CHANGED": "CHANGED"
        },
        "notProvisioned": "{{app}} gets no own address on these tenants",
        "previousApp": "The previous app",
        "truncated": "Showing part of the list — the counts are exact.",
        "result": "Primary app updated: {{moved}} moved, {{skipped}} skipped.",
        "showDetails": "Show details",
        "hideDetails": "Hide details"
      },
      "isPrimaryHint": "Or make another app primary first (Make primary on that app), then delete this one.",
      "firstAppPrimary": {
        "PUBLIC": "This is the product's first public app, so it becomes the primary app.",
        "SELF_CONTAINED": "This is the product's first self-contained app, so it becomes the primary app."
      },
      "primaryFallbackFailed": "App created, but it couldn't be made primary — use Make primary,",
      "primaryConflict": "Another app was just added to this product. The list has been refreshed — review and save again.",
      "emptyRole": "No app assigned to this role.",
      "retagPrompt": "After the recent app-role update, existing apps are all 'Public'. If one of these is your per-tenant staff console, use Change role → Tenant-Admin.",
      "optIn": {
        "label": "Per-tenant opt-in",
        "help": "When on, tenants get this app's affiliate host only where you enable it (Tenant → App builds). When off, every tenant of the product gets one.",
        "chip": "Per-tenant opt-in",
        "offTitle": "Give every tenant an affiliate host?",
        "offBody": "Turning per-tenant opt-in off creates affiliate.<tenant>.<base> for every tenant of this product and deploys routing.",
        "offConfirm": "Turn opt-in off"
      },
      "subTabs": {
        "ariaLabel": "App roles",
        "public": "Public Apps",
        "tenantAdmin": "Tenant Admin",
        "api": "API",
        "affiliate": "Affiliate",
        "selfContained": "Self-contained",
        "resellerAdmin": "Reseller Admin",
        "productAdmin": "Product Admin"
      },
      "roles": {
        "PUBLIC": {
          "label": "Public apps",
          "description": "Tenant-facing front-ends; one is normally the product's primary app.",
          "host": "<app-slug>.<tenant>.<base>",
          "hostPrimary": "<tenant>.<base>",
          "add": "Add public app"
        },
        "TENANT_ADMIN": {
          "label": "Tenant-Admin",
          "description": "The optional per-tenant staff console.",
          "host": "admin.<tenant>.<base>",
          "add": "Add Tenant-Admin"
        },
        "PRODUCT_ADMIN": {
          "label": "Product-Admin",
          "description": "The optional staff console shared across this product.",
          "host": "admin.{{slug}}.<base>",
          "add": "Add Product-Admin"
        },
        "SELF_CONTAINED": {
          "label": "Self-contained app",
          "description": "A single deployment that serves its own front end and back end.",
          "host": "<app-slug>.<tenant>.<base>",
          "hostPrimary": "<tenant>.<base>",
          "add": "Add self-contained app"
        },
        "API": {
          "label": "API",
          "description": "Where this product's API is served from. Leave empty to use the shared application pool.",
          "host": "Reached at api.<each front-end host> (auto)",
          "add": "Add API"
        },
        "RESELLER_ADMIN": {
          "label": "Reseller-Admin",
          "description": "The console reseller companies use to manage the tenants they sell.",
          "host": "reseller.{{slug}}.<base>",
          "add": "Add reseller console"
        },
        "AFFILIATE": {
          "label": "Affiliate",
          "description": "The app tenants' affiliates use. One per product; never primary.",
          "host": "affiliate.<tenant>.<base>",
          "add": "Add affiliate app"
        }
      },
      "exclusivity": {
        "blockedBySelfContained": "This product has a self-contained app, so it can't have other apps.",
        "selfContainedNeedsEmpty": "A self-contained app must be the only app — remove the others first.",
        "topologyMismatchComposed": "This product is composed — a self-contained app is not available. Change packaging first if you need one.",
        "topologyMismatchSelfContained": "This product is self-contained — only its single self-contained app is allowed."
      },
      "changeRole": {
        "action": "Change role",
        "title": "Change app role?",
        "body": "Change {{name}} from {{from}} to {{to}}?",
        "confirm": "Change role"
      },
      "scope": {
        "tenant": "Tenant app",
        "tenantHelper": "One URL per tenant (…<slug>.<tenant>.<base>).",
        "product": "Product admin app",
        "productHelper": "One URL for the whole product (admin.<product-slug>.<base>).",
        "frontendOnly": "Product admin apps must be front-ends.",
        "productUrl": "Serves admin.{{slug}}.<base> — one URL for the whole product.",
        "fixedAfterCreate": "Scope is set when the app is created and can't be changed here."
      },
      "scopeBadge": {
        "product": "Product admin"
      },
      "columns": {
        "slug": "Slug",
        "displayName": "Display name",
        "role": "Role",
        "kind": "Kind",
        "docrootUpstream": "Docroot / Upstream"
      },
      "kinds": {
        "FRONTEND": "Front-end",
        "BACKEND": "Back-end",
        "SELF_CONTAINED": "Self-contained"
      },
      "fields": {
        "slug": "Slug",
        "slugHelper": "Lowercase letters, numbers, hyphens. Unique within the product.",
        "slugRenameHelper": "Renaming changes the default URL (…<slug>.<tenant>.<base>) on every tenant of this product; custom domains keep their name.",
        "displayName": "Display name",
        "scope": "Scope",
        "kind": "Kind",
        "kindHelper": "Front-end apps are served from a Caddy docroot; back-end apps are a product API proxied to an upstream.",
        "docroot": "Docroot",
        "docrootHelper": "Absolute path under the platform's htdocs base (e.g. C:/caddy/htdocs/athena-timesheet).",
        "upstream": "Upstream",
        "upstreamHelper": "The server Caddy forwards this product's API to (e.g. athena-prod01). Customers still point their DNS at the platform edge — this is only where the edge proxies after TLS.",
        "cspFrameSrc": "Allowed iframe sources",
        "cspFrameSrcHelper": "Space-separated. blob: (in-page file previews), https:// origins and/or https://*.domain this app may show in an iframe, e.g. blob: https://aem.cnppowerforms.com. At most 8.",
        "siteType": "Site type",
        "siteTypeApp": "Application: every unknown path loads the app",
        "siteTypeStatic": "Static site: real pages, and a real 404 that serves /404.html",
        "siteTypeStaticChip": "Static site",
        "cspScriptSrc": "Allowed script sources",
        "cspConnectSrc": "Allowed connect sources",
        "cspSourcesHelper": "Space-separated https:// origins or https://*.domain, at most 12. Third-party scripts or APIs this app's pages may use (e.g. analytics, chat widgets). Only add sources you trust; they run inside this app's pages.",
        "cspFormAction": "Allowed form-action sources",
        "cspFormActionHelper": "Other sites this app's forms may submit to (e.g. https://api.themoneymeeting.ai). Space-separated https:// origins or https://*.domain, at most 12.",
        "cspStyleSrc": "Allowed style sources",
        "cspStyleSrcHelper": "Stylesheet origins added to this app's style-src.",
        "cspFontSrc": "Allowed font sources",
        "cspFontSrcHelper": "Web-font origins added to this app's font-src.",
        "needsNewerAuth": "Site type and extra CSP sources appear once saas-auth is updated."
      },
      "rename": {
        "snack": "App updated — renamed {{hosts}} default hosts across {{tenants}} tenants.",
        "snackProduct": "App updated — slug renamed.",
        "confirmTitle": "Rename this app?",
        "confirmBody": "Renaming “{{old}}” to “{{new}}” changes the default hostname on every tenant of this product (…{{new}}.<tenant>.<base>) and reloads routing. Anyone using the old default URL will need the new one. Custom domains for this app are not renamed.",
        "confirmLabel": "Rename"
      },
      "deleteTitle": "Delete app?",
      "deleteBody": "Delete {{name}}? This also removes the app's platform hostnames on every tenant and revokes pending invitations to it. This cannot be undone.",
      "deleteBodyProduct": "Delete {{name}}? This cannot be undone.",
      "deletedCounts": "App deleted. Removed {{hosts}} platform hostname(s); revoked {{invites}} pending invitation(s).",
      "deleteHostnamesHint": "If hostnames are still assigned to this app, reassign them first."
    },
    "resellerAdmin": {
      "title": "Reseller admin",
      "explainer": "The reseller console is the app reseller companies use to manage the tenants they sell. Resellers and their users are managed in the product's admin console.",
      "addConsole": "Add reseller console",
      "needsProductConsole": "Create the Product Admin console first.",
      "consoleLoadError": "Reseller console details couldn't be loaded. Its existence is unknown, so adding a console is unavailable.",
      "appSection": "Reseller console",
      "consoleUrl": "Console URL",
      "hostnamesExplainer": "Reseller hostnames are derived from the product slug, the platform base and (when set) the product base domain. On the product domain the console also uses the Product Admin console's auth host — verify that one on the Product Admin tab. After a successful check, run Deploy Platform Routing.",
      "delete": {
        "title": "Delete reseller console?",
        "body": "Deleting {{name}} removes the reseller console's hosts. Resellers keep their users and tenant assignments, but can't sign in until a reseller console exists again.",
        "success": "Reseller console deleted."
      },
      "errors": {
        "APP_ROLE_SINGLETON_CONFLICT": "This product already has a reseller console.",
        "APP_SELF_CONTAINED_EXCLUSIVE": "Self-contained products can't have a reseller console.",
        "RESERVED_APP_SLUG": "That name is reserved — try {{slug}}-reseller-admin."
      }
    },
    "productAdmins": {
      "noConsole": "This product has no product-admin console. Add one to give staff a single URL for administering this product across every tenant.",
      "noConsoleSelfContained": "This product is self-contained, so it can't have a separate product-admin console. Change its packaging before adding one.",
      "addConsole": "Add product admin console",
      "consoleLoadError": "Product-admin console details couldn't be loaded. Its existence is unknown, so adding a console is unavailable.",
      "peopleLoadError": "Product admins couldn't be loaded. Console app details remain available.",
      "appSection": "Product admin console",
      "peopleSection": "People",
      "hostnames": {
        "explainer": "Console hostnames are derived from the product slug, the platform base and (when set) the product base domain. Point *.<base domain> at the platform host, Check DNS on each row, then Deploy Platform Routing.",
        "loadError": "Console hostnames couldn't be loaded.",
        "empty": "No console hostnames yet.",
        "columns": {
          "hostname": "Hostname",
          "type": "Type",
          "status": "Status"
        },
        "status": {
          "verified": "Verified · {{date}}",
          "unverified": "Unverified"
        },
        "platformDefault": "Platform default",
        "checkDns": "Check DNS",
        "recheck": "Re-check",
        "notConfigured": "DNS verification is not configured on this environment",
        "deployReminder": "DNS verified. Deploy routing to make this hostname live: Operations → Deploy Platform Routing."
      }
    },
    "fields": {
      "displayName": "Display name",
      "slug": "Slug",
      "slugImmutable": "Can't be changed after create",
      "jwtAudience": "JWT audience",
      "jwtAudienceImmutable": "Can't be changed after create",
      "defaultMfaPolicy": "Default MFA policy",
      "defaultMfaReverifyDays": "Reverify days",
      "defaultMfaTrustedDeviceDays": "Trusted-device days",
      "defaultBrandId": "Default brand",
      "defaultBrandHelper": "Only brands of this product. Clear to inherit none.",
      "defaultBrandNone": "— None —",
      "guestSignupUrl": "Guest signup URL",
      "guestSignupUrlHelper": "Relative path starting with “/” (e.g. /guest/book). Applies to all tenants of this product — each resolves it against its own primary APP host.",
      "guestSignupLabel": "Guest signup label",
      "guestSignupLabelHelper": "Link text on the login page. Defaults to “Continue as guest” when blank.",
      "guestVerificationEnabled": "Enable guest email verification",
      "guestVerificationEnabledHelper": "Lets tenants of this product issue guest email-verification codes for guest checkout. Applies to every tenant of this product.",
      "productGroup": "Group",
      "productGroupHelper": "Pick an existing group or type a new one.",
      "productGroupPlaceholder": "Default",
      "authMode": "Authentication",
      "authModeHelper": "External marks a product whose apps sign in via their own SSO (e.g. Entra). Presentation only — it changes no authentication.",
      "appTopology": "Packaging",
      "appTopologyHelper": "Composed — the UI and API are separate hosts. Self-contained — one WAR serves both behind a single public URL.",
      "apiContextRoot": "API context root",
      "apiContextRootHelper": "The path the product’s API is deployed under on the app server. Never shown to users — requests arrive at /api and are rewritten to this.",
      "apiContextRootInvalid": "Must start with “/” and contain no spaces, no “..”, and no second “/”.",
      "productAdminMfaRequired": "Require MFA for product administrators",
      "productAdminMfaRequiredHelper": "When on, anyone signing in to this product's admin console must complete an email verification code every time. Applies to the product-admin console only — not tenant/customer logins.",
      "selfServiceTenantCreate": "Allow self-service tenant creation",
      "selfServiceTenantCreateHelper": "Lets this product's backend create tenants from its own public signup, server to server, with no admin. Capped per day.",
      "resellerMfaPolicy": "Reseller MFA policy",
      "resellerMfaPolicyHelper": "Applies to reseller users signing in to this product's reseller console.",
      "resellerMfaPolicyOptions": {
        "REQUIRED": "Required — \"remember this device\" allowed",
        "ALWAYS": "Always — every sign-in",
        "OPTIONAL": "Optional — each user chooses",
        "DISABLED": "Off"
      },
      "baseDomain": "Base domain"
    },
    "mfa": {
      "REQUIRED": "Required",
      "OPTIONAL": "Optional",
      "DISABLED": "Disabled",
      "ALWAYS": "Always"
    },
    "authModes": {
      "PLATFORM": "Platform",
      "EXTERNAL": "External"
    },
    "packaging": {
      "COMPOSED": "Composed",
      "SELF_CONTAINED": "Self-contained",
      "confirmTitle": "Change packaging?",
      "confirmBody": "Changing packaging does NOT clean up existing hostnames. It affects newly provisioned tenants only. Existing tenants keep the hostnames they already have — remove them manually from each tenant's Whitelabel tab if they are no longer wanted.",
      "confirmAction": "Change packaging"
    },
    "baseDomain": {
      "helper": "Leave empty to use the platform default. Changing this rehomes every existing tenant of this product.",
      "platformDefault": "the platform default",
      "confirmTitle": "Rehome tenants to a new base domain?",
      "confirmBody": "This will rewrite {{rewritten}} hostnames across {{tenants}} tenants and move them from {{from}} to {{to}}.",
      "confirmLeftAlone": "{{count}} hostnames are deliberately left alone (vanity domains and platform-level rows). This is normal.",
      "confirmOrder": "Do these in order: 1. point DNS *.{{to}} at the edge, 2. run this rehome, 3. deploy platform routing, 4. re-register OAuth redirect URIs (Google, Entra, GHL).",
      "confirmSessions": "Users of rehomed tenants are signed out once: the session cookie is scoped to the tenant apex, whose domain is changing.",
      "confirmOauth": "External OAuth redirect URIs will break. Google, Entra and GHL hold callbacks on the old hostnames and nothing here can update them — the symptom is a login that fails only for social/SSO users.",
      "confirmAction": "Rehome tenants",
      "success": "Rewrote {{rewritten}} hostnames across {{tenants}} tenants, moving them from {{from}} to {{to}}. {{leftAlone}} left alone.",
      "collisions": "Nothing was changed. These target hostnames are already taken, so the rehome was aborted rather than leaving this product split across two domains:",
      "deployRequired": "Not serving yet — the hostname rows were rewritten in the database, but routing has not been deployed. Until you deploy platform routing, the old hosts still serve and the new ones do not exist."
    },
    "ghlMarketplace": {
      "title": "GHL Marketplace app",
      "unconfigured": "This product does not talk to GoHighLevel until a Marketplace app is registered.",
      "register": "Register app",
      "registerTitle": "Register GHL Marketplace app",
      "editTitle": "Edit GHL Marketplace app",
      "saved": "GHL Marketplace app saved.",
      "deleted": "GHL Marketplace app deleted.",
      "deleteTitle": "Delete GHL Marketplace app?",
      "deleteBody": "This product stops authenticating to GoHighLevel, and existing install rows are orphaned.",
      "secretResolved": "Secret resolved",
      "secretMissing": "Secret missing",
      "secretMissingConsequence": "The client secret does not resolve from Key Vault. Installs will fail at token exchange.",
      "fields": {
        "clientId": "Client ID",
        "clientSecretVaultName": "Client secret vault name",
        "clientSecretVaultNamePlaceholder": "saasauth-ghl-app-{{slug}}-client-secret",
        "clientSecretVaultNameHelper": "Always sent as-is on save. The convention shown as placeholder text is not applied unless typed.",
        "redirectUri": "Redirect URI",
        "redirectUriHint": "Expected shape: https://<auth host>/api/oauth/crm/callback/<product-slug>",
        "scopes": "Scopes",
        "status": "Status"
      },
      "errors": {
        "redirectUriGhlSegment": "GHL's white-label filter rejects any redirect URL containing 'ghl'. Use /crm/ — this is why installs silently failed before.",
        "redirectUriInvalid": "Enter an absolute https:// URL."
      },
      "installs": {
        "title": "Installs",
        "empty": "No installs yet. Install the app into a sub-account from the GHL Marketplace — installs appear here once the callback completes.",
        "agency": "Agency",
        "revoked": "This install was revoked after a token refresh failed. Reinstall the app in this sub-account to restore it.",
        "orphaned": "No tenant claims this location. Check the intended tenant's Integration Settings location id.",
        "userTypes": {
          "LOCATION": "Location"
        },
        "statuses": {
          "ACTIVE": "Active",
          "REVOKED": "Revoked"
        },
        "columns": {
          "userType": "Type",
          "companyId": "Company",
          "locationId": "Location",
          "status": "Status",
          "expiresAt": "Expires",
          "scopes": "Scopes",
          "tenant": "Tenant"
        }
      }
    },
    "agents": {
      "title": "Agent clients",
      "explanation": "Public OAuth 2.1 + PKCE clients bound to this product and one login tenant. Disable stops new authorizations; there is no delete.",
      "empty": "No agent clients yet.",
      "superAdminRequired": "Super admin required to manage agent clients.",
      "new": "New agent client",
      "create": "Create",
      "createTitle": "New agent client",
      "created": "Agent client created.",
      "enable": "Enable",
      "disable": "Disable",
      "enabledSnack": "Agent client enabled.",
      "disabledSnack": "Agent client disabled.",
      "addUri": "Add",
      "saveRedirects": "Save redirect URIs",
      "saveScopes": "Save scopes",
      "redirectsSaved": "Redirect URIs saved.",
      "scopesSaved": "Scopes saved.",
      "copyAuthorizeUrl": "Copy authorize URL",
      "copyTokenUrl": "Copy token URL",
      "urlHelper": "Paste these into the agent platform's OAuth form; PKCE S256, no client secret.",
      "tenantsLoadError": "Active tenants couldn't be loaded.",
      "tenantsEmpty": "No active tenants for this product.",
      "columns": {
        "clientName": "Name",
        "clientId": "Client ID",
        "loginTenant": "Login tenant",
        "scopes": "Scopes",
        "enabled": "Enabled",
        "createdAt": "Created"
      },
      "fields": {
        "clientId": "Client ID",
        "clientIdHelper": "Must match {{pattern}}.",
        "clientName": "Name",
        "loginTenant": "Login tenant",
        "loginTenantHelper": "ACTIVE tenants of this product only.",
        "redirectUris": "Redirect URIs",
        "redirectUriInput": "Add redirect URI",
        "redirectUrisHelper": "1–10 URIs. https://… (no fragment), http://localhost or http://127.0.0.1, or a custom scheme.",
        "scopes": "Scopes",
        "scopesHelper": "A subset of this product's published scopes ({{slug}}:*). Empty is allowed.",
        "authorizeUrl": "Authorize URL",
        "tokenUrl": "Token URL"
      },
      "errors": {
        "INVALID_CLIENT_ID": "Client ID must match ^[a-z0-9][a-z0-9-]{2,63}$.",
        "CLIENT_ID_TAKEN": "That client ID is already in use.",
        "INVALID_REDIRECT_URI": "Redirect URIs must be https://… (no fragment), http://localhost or http://127.0.0.1, or a custom scheme.",
        "INVALID_SCOPE": "Scopes must be a subset of this product's published catalog.",
        "TENANT_NOT_IN_PRODUCT": "That tenant is not in this product.",
        "TENANT_NOT_ACTIVE": "That tenant is not active."
      },
      "scopes": {
        "title": "Scopes",
        "explanation": "Published by the product backend. Agents request these at sign-in; the person sees the description on the consent page.",
        "empty": "This product has not published any scopes yet.",
        "deleted": "Scope deleted.",
        "deleteTitle": "Delete scope?",
        "deleteBody": "Agents that were granted this scope lose it on their next token refresh.",
        "columns": {
          "scope": "Scope",
          "description": "Description",
          "updatedAt": "Updated"
        }
      }
    }
  },
  "tenantOidcSso": {
    "title": "Connected Apps (OIDC)",
    "intro": "Which registered apps (OIDC clients) this tenant's members can sign into using their Journix identity. Each row is a member; each column is an app that allow-lists this tenant.",
    "member": "Member",
    "empty": "No members yet.",
    "noClients": "This tenant isn't allow-listed on any OIDC client.",
    "unavailable": "Not available yet.",
    "columnUnavailable": "Unavailable",
    "accessGranted": "Granted",
    "accessDisabled": "Disabled",
    "accessNotGranted": "Not granted",
    "grant": "Grant",
    "disable": "Disable",
    "grantAction": "grant",
    "disableAction": "disable",
    "grantFailed": "Couldn't {{action}} {{member}}'s access to {{client}} — please retry.",
    "refreshFailed": "Change submitted, but the access grid could not be refreshed — reload to confirm."
  },
  "productOidcClients": {
    "title": "OIDC clients",
    "explanation": "The OIDC clients in scope for this product. Product-scoped clients can be removed here; platform-scoped clients apply to all products and are managed on the client's own page.",
    "empty": "No OIDC clients.",
    "superAdminRequired": "Super admin required to manage OIDC clients.",
    "allProductsBadge": "All products",
    "columns": {
      "name": "Name",
      "clientId": "Client ID",
      "scope": "Scope"
    },
    "scopeProduct": "Product",
    "scopePlatform": "Platform",
    "remove": "Remove",
    "removeTitle": "Remove OIDC client?",
    "removeBody": "Remove {{name}} from this product? Its tenants will no longer be able to use this client (unless another product still allows it).",
    "removed": "OIDC client removed from product.",
    "platformScopedError": "This client applies to all products; change its access scope on the client's page to remove it."
  },
  "oidc": {
    "list": {
      "title": "OIDC clients",
      "subtitle": "Federation registry — third-party app integrations.",
      "create": "Create client",
      "empty": "No OIDC clients registered.",
      "accessScope": "Access scope",
      "scopePlatform": "Platform",
      "scopeProduct": "Product ({{count}})"
    },
    "detail": {
      "scopes": "Scopes",
      "redirectUris": "Redirect URIs",
      "postLogoutRedirectUris": "Post-logout redirect URIs",
      "accessScope": "Access scope",
      "accessScopePlatform": "Platform-scoped (all products)",
      "accessScopeProduct": "Product-scoped",
      "accessScopePlatformHelp": "All products and their tenants can use this client. The common GHL case.",
      "accessScopeProductHelp": "Only the chosen products' tenants can use this client.",
      "products": "Products",
      "addProduct": "Add product",
      "allProductsAllowed": "All products are already allowed.",
      "selectAtLeastOneProduct": "Select at least one product.",
      "platformClearHint": "Remove all products to make this client platform-scoped.",
      "removeProductTitle": "Remove product?",
      "removeProductBody": "Remove {{product}} from this client’s allowed products?",
      "rotate": "Rotate secret",
      "disable": "Disable",
      "effectiveMembers": "Effective members",
      "effectiveUnavailable": "Not available yet.",
      "effectiveEmpty": "No members in the allowed tenants yet.",
      "effectiveTenant": "Tenant",
      "effectiveMember": "Member",
      "effectiveAccess": "Access",
      "accessGranted": "Granted",
      "accessDisabled": "Disabled",
      "accessNotGranted": "Not granted",
      "accessGrant": "Grant",
      "accessDisable": "Disable",
      "effectiveEligible": "Eligible",
      "effectiveInactive": "Membership inactive",
      "effectiveNotEligible": "Not eligible",
      "effectiveSsoOff": "SSO disabled",
      "loginBrand": "Login & brand host",
      "loginMode": "Login mode",
      "loginModePlatform": "Platform-scoped",
      "loginModePlatformHelp": "Auth across the allowed tenants on the platform login host — no single login tenant.",
      "loginModeTenant": "Tenant-scoped",
      "brandHost": "Brand host",
      "brandHostDefault": "Platform default (follows public origin)"
    },
    "create": {
      "title": "Create OIDC client",
      "step1": "Identity",
      "step2": "Endpoints & scopes",
      "step3": "Access scope",
      "brandHost": "Brand host",
      "brandHostHelper": "Defaults to the platform auth host. Override only if this client authenticates on a different brand host.",
      "integrationType": "Integration type",
      "accessScope": "Access scope",
      "accessScopePlatform": "Platform-scoped (all products)",
      "accessScopeProduct": "Product-scoped",
      "accessScopePlatformHelp": "All products and their tenants can use this client. The common GHL case.",
      "accessScopeProductHelp": "Only the chosen products' tenants can use this client.",
      "productPicker": "Products",
      "productPickerPlaceholder": "Select products",
      "selectAtLeastOneProduct": "Select at least one product.",
      "loginMode": "Login mode",
      "loginModePlatform": "Platform-scoped (default)",
      "loginModePlatformHelp": "Auth across the allowed tenants on the platform login host — no single login tenant. The common GHL case.",
      "loginModeTenant": "Tenant-scoped",
      "loginModeTenantHelp": "A specific tenant's users log in to that tenant.",
      "loginTenant": "Login tenant",
      "loginTenantPlaceholder": "Select a login tenant",
      "loginTenantHelper": "The tenant whose login host this client uses.",
      "loginTenantSearching": "Searching…",
      "loginTenantNoMatches": "No matching active tenants.",
      "loginTenantSearchHint": "Type to search active tenants.",
      "errors": {
        "LOGIN_HOSTNAME_REQUIRED": "Chosen login tenant has no LOGIN/APP hostname — pick another or add one.",
        "REDIRECT_URI_INVALID": "Redirect URIs must be https://.",
        "BRAND_HOST_REQUIRED": "A brand host is required for this client."
      }
    },
    "secret": {
      "title": "Save this secret now",
      "body": "This is the only time you will see this secret. Copy it to your password manager before closing.",
      "acknowledge": "I've saved this in a password manager"
    },
    "providerDisabled": "OIDC provider is disabled in this environment."
  },
  "wizards": {
    "newTenant": {
      "title": "New tenant",
      "whatsThis": "What's this?",
      "continue": "Continue",
      "steps": {
        "product": "Product",
        "basics": "Tenant basics",
        "branding": "Branding",
        "urls": "URLs",
        "users": "Users",
        "golive": "Go-live"
      },
      "explain": {
        "product": "A product is the app this customer signs in to (for example, the PSA timesheet app). It decides which brands the tenant can use and what the login looks like by default.",
        "basics": "A tenant is one customer organization. The slug is its permanent, lowercase ID and can't be changed later. The display name is what people see. The signup mode decides who's allowed to create accounts.",
        "branding": "Branding is how the login page looks for this tenant. By default it inherits the product's default brand, which is the recommended choice. You can instead pick a specific brand made for this product.",
        "urls": "Every tenant gets platform URLs automatically — they're below. You can also put it on the customer's own domain (white-label). That's optional, and you can do it later from the tenant's Whitelabel tab.",
        "users": "Invite the first people for this tenant by email — each gets a one-time link to set up their account. Credentials are per-tenant: even someone who already has a login on another tenant needs an invite here to access this one. This step is optional — you can skip it and invite people later from the tenant's Invitations tab.",
        "golive": "Final checks, run automatically: the login page resolves its brand at this hostname, and a valid HTTPS certificate has been issued. The very first request to a brand-new hostname can take a few seconds while the certificate is created — re-check if it's not green yet."
      },
      "signupModeDesc": {
        "INVITE_ONLY": "Only people you invite can join (recommended).",
        "PUBLIC": "Anyone can sign themselves up.",
        "ADMIN_CREATED_ONLY": "Only admins create accounts; no self-signup.",
        "DISABLED": "No new sign-ups at all."
      },
      "product": {
        "pick": "Pick an existing product",
        "create": "Create a new product",
        "createHint": "Rare — most tenants reuse an existing product.",
        "createSubmit": "Create product",
        "advancedNote": "Advanced settings (MFA timing) use sensible defaults — edit them later in Products.",
        "selected": "Product selected: {{name}}",
        "displayName": "Display name",
        "slug": "Slug",
        "jwtAudience": "JWT audience (unique)",
        "mfaPolicy": "Default MFA policy"
      },
      "basics": {
        "create": "Create tenant",
        "created": "Tenant created: {{name}}"
      },
      "branding": {
        "inherit": "Inherit the product's default brand (recommended)",
        "pick": "Pick a specific brand",
        "noBrands": "No brands exist for this product yet.",
        "editorLink": "Need a new brand? Open the brand editor.",
        "inheriting": "Inheriting the product's default brand",
        "using": "Using brand: {{name}}"
      },
      "urls": {
        "systemTitle": "System URLs",
        "noSystem": "This tenant has no system URLs because no base domain is configured for its product or the platform. Set the product's base domain (or the platform default), then reload this page. A white-label domain needs the system URLs to exist first.",
        "whitelabelTitle": "White-label domain (optional)"
      },
      "users": {
        "email": "Email",
        "role": "Role",
        "addRow": "Add another",
        "send": "Send invitations",
        "skip": "Skip",
        "skipped": "Skipped — no invitations sent",
        "skippedShort": "Skipped",
        "none": "None",
        "doneCount": "{{count}} invitation(s) sent"
      },
      "golive": {
        "live": "This tenant is live",
        "checking": "Checking:",
        "wlDraft": "The white-label domain is still in Draft, so these checks use the system URL. Verify DNS on the URLs step to switch to it.",
        "deploy": "Deploy this tenant's routing",
        "brandingTitle": "Branding resolves",
        "brandingWaiting": "The login page is not resolving its brand at this hostname yet.",
        "httpsTitle": "HTTPS certificate",
        "httpsOk": "Certificate issued — HTTPS is working",
        "httpsWaiting": "No valid HTTPS certificate yet. The first request to a new hostname can take a few seconds while the certificate issues — re-check shortly.",
        "httpsReason": "Reason: {{reason}}",
        "recheck": "Re-check"
      },
      "finish": {
        "title": "Tenant is set up",
        "tenantLabel": "Tenant",
        "productLabel": "Product",
        "brandLabel": "Brand",
        "hostnameLabel": "Hostname",
        "statusLabel": "Status",
        "notLive": "Not live yet",
        "dnsLive": "Verified — live",
        "usersLabel": "Invited users",
        "finishGoLive": "Finish the Go-live step above to bring {{hostname}} online.",
        "viewTenant": "Go to tenant"
      }
    },
    "reassignProduct": {
      "title": "Reassign product",
      "step1": "Clear current brand",
      "step2": "Change product",
      "step3": "Pick a new brand",
      "preempt": "This tenant has a brand assigned. Clear it before changing the product."
    }
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "network": "Network error. Check your connection and try again.",
    "rateLimited": "Too many requests. Please wait a moment and try again.",
    "insufficientPermissions": "You don't have permission for this action.",
    "superAdminRequired": "Requires Super admin.",
    "forbiddenTitle": "Insufficient permissions",
    "forbiddenBody": "You don't have permission to view this. This action requires Super admin.",
    "notFoundTitle": "Not found",
    "notFoundBody": "We couldn't find what you were looking for.",
    "codes": {
      "INVALID_RETURN_URL": "The return URL is not registered for this tenant.",
      "SESSION_EXPIRED": "Your session has expired. Sign in again.",
      "CSRF_VALIDATION_FAILED": "Security check failed. Reload and try again.",
      "INVALID_CREDENTIALS": "Email or password is incorrect.",
      "PRODUCT_NOT_FOUND": "Product not found.",
      "PRODUCT_SLUG_TAKEN": "That slug is already used by another product.",
      "JWT_AUDIENCE_TAKEN": "That JWT audience is already used by another product.",
      "RESERVED_JWT_AUDIENCE": "That JWT audience is reserved and cannot be used.",
      "CANONICAL_AUTH_HOSTNAME_TAKEN": "That canonical auth hostname is already used by another product.",
      "CANONICAL_LOGIN_HOSTNAME_TAKEN": "That canonical login hostname is already used by another product.",
      "PRODUCT_IN_USE": "This product is still referenced by one or more tenants or brands and can't be deleted.",
      "INVALID_APP_DOCROOT": "Docroot must be an absolute path under the platform's htdocs base.",
      "APP_HAS_HOSTNAMES": "This app still has hostnames assigned. Reassign them to another app first.",
      "APP_SLUG_TAKEN": "An app with this slug already exists on this product.",
      "RESERVED_APP_SLUG": "That slug is reserved.",
      "PRIMARY_APP_MUST_BE_FRONTEND": "Only a front-end app can be the primary app.",
      "APP_ROLE_SINGLETON_CONFLICT": "This product already has an app in that role.",
      "PRIMARY_APP_MUST_BE_PUBLIC": "Only a public app can be the primary app.",
      "APP_ROLE_IMMUTABLE": "This app's role can't be changed (only Public ↔ Tenant-Admin is allowed).",
      "APP_ROLE_CHANGE_BLOCKED": "Clear this app's Primary flag before changing its role.",
      "PRIMARY_CONFLICT": "Another primary change happened just now — reload and retry.",
      "APP_SELF_CONTAINED_EXCLUSIVE": "A self-contained app must be the only app in its product.",
      "RESELLER_CONSOLE_REQUIRES_PRODUCT_CONSOLE": "Create the product's Product Admin console first.",
      "PRODUCT_CONSOLE_REQUIRED_BY_RESELLER_CONSOLE": "This product has a reseller console, which needs the Product Admin console. Delete the reseller console first.",
      "PRODUCT_SCOPE_REQUIRES_FRONTEND": "Product admin apps must be front-ends.",
      "APP_SCOPE_CHANGE_BLOCKED": "This app's scope can't be changed while it has hostnames.",
      "BACKEND_APP_HAS_DOCROOT": "Back-end apps don't use a docroot — clear it (use an upstream instead).",
      "SELF_CONTAINED_APP_HAS_DOCROOT": "Self-contained apps don't use a docroot — clear it (use an upstream instead).",
      "FRONTEND_APP_HAS_UPSTREAM": "Front-end apps don't use an upstream — clear it (use a docroot instead).",
      "UPSTREAM_REQUIRED": "Enter an upstream host:port for this back-end app.",
      "INVALID_UPSTREAM": "Upstream must be a host with an optional port (e.g. athena-prod01 or athena-prod01:8443).",
      "UPSTREAM_NOT_ALLOWED": "That upstream host isn't on the operator allow-list. Ask ops to add it first.",
      "APP_KIND_CHANGE_BLOCKED": "Reassign this app's hostnames before changing its kind.",
      "APP_PRODUCT_MISMATCH": "That app belongs to a different product. Pick an app from this tenant's product.",
      "APP_ON_NON_APP_HOSTNAME": "Only APP-type hostnames can be assigned to an app.",
      "APP_NOT_FOUND": "That app no longer exists. Refresh and pick another.",
      "DEPLOY_DISPATCH_FAILED": "Deployment couldn't start — try again.",
      "DEPLOY_NOT_CONFIGURED": "Routing deploy isn't configured yet — contact ops.",
      "CADDY_CONFIG_INVALID": "Caddy rejected the generated config — the last-good config is still being served. See the error detail.",
      "CADDY_RELOAD_FAILED": "Caddy reload failed — the last-good config is still being served. See the error detail.",
      "CADDY_HELD_BACK_HOST_CONFLICT": "Routing not deployed: a held-back fragment's previous routing still claims a hostname that now belongs to someone else.",
      "HOSTNAME_IS_REDIRECT_TARGET": "Another hostname redirects to this one. Change or remove that redirect first.",
      "APP_IS_PRIMARY": "This is the product's primary app. Make another app primary first.",
      "INVALID_DNS_TARGET": "Each DNS target must be a bare hostname or IPv4 address — no scheme, port, path, or spaces.",
      "BRAND_NOT_FOUND": "Brand not found.",
      "BRAND_NOT_CONFIGURED": "No brand configured for this tenant or product.",
      "BRAND_PRODUCT_MISMATCH": "This brand belongs to a different product than the tenant.",
      "BRAND_MUST_BE_CLEARED_FIRST": "Clear the tenant's brand before changing the product.",
      "BRAND_IN_USE": "This brand is in use by one or more tenants.",
      "BRAND_IS_PRODUCT_DEFAULT": "This brand is the default for its product.",
      "BRAND_SLUG_TAKEN": "This slug is already in use for this product.",
      "INVALID_AUTH_PROVIDER": "Auth providers may only contain 'password', 'google', or 'microsoft'.",
      "INVALID_TEMPLATE": "Template must be one of: centered, split-hero, backdrop.",
      "INVALID_GUEST_SIGNUP_URL": "Guest signup URL must be a relative path starting with “/” (no scheme or host).",
      "RESERVED_COPY_KEY": "Remove reserved keys from Copy & providers before saving.",
      "SAAS_ADMIN_PRODUCT_IMMUTABLE": "The platform tenant's product cannot be changed.",
      "INVALID_IMAGE": "The file could not be read as an image. Please select a valid PNG or JPEG.",
      "UNSUPPORTED_IMAGE_TYPE": "Only PNG and JPEG images are supported.",
      "IMAGE_TOO_LARGE": "Image must be 5 MB or smaller.",
      "IMAGE_DIMENSIONS_TOO_LARGE": "Image dimensions must be 4096×4096 or smaller.",
      "INVALID_ASSET_BASE_URL": "The custom base URL is invalid. Must be a valid http(s) URL.",
      "SVG_REJECTED": "This SVG can't be used safely.",
      "ASSET_DIMENSIONS": "The image isn't the required size.",
      "ASSET_TYPE": "This file type isn't allowed for this image.",
      "ASSET_TOO_LARGE": "File is over 5 MB.",
      "BUNDLE_TOO_LARGE": "This bundle is over 10 MB.",
      "BUNDLE_INVALID": "The bundle has errors. Nothing was changed.",
      "INVALID_HOSTNAME": "Enter a valid hostname.",
      "HOSTNAME_ALREADY_REGISTERED": "This hostname is already registered.",
      "PRIMARY_HOSTNAME_DELETE_BLOCKED": "This is the primary hostname for its type. Make another host primary before deleting it.",
      "HOSTNAME_NOT_DNS_VERIFIED": "Verify this hostname's DNS before making it primary.",
      "HOSTNAME_TYPE_CONTRADICTS_PRODUCT_POSTURE": "This hostname type isn't available for this product's configuration.",
      "WHITELABEL_AUTH_HOST_NOT_VERIFIED": "This tenant has no active white-label domain with a verified auth host. Activate a white-label domain with an auth host first.",
      "WHITELABEL_IN_USE_BY_MICROSOFT_SSO": "Microsoft SSO uses this domain. Switch it to the System redirect URI first.",
      "AUTH_HOST_IN_USE_BY_MICROSOFT_SSO": "Microsoft SSO uses this auth host. Switch it to the System redirect URI first.",
      "LAST_OWNER_PROTECTED": "This is the tenant's only Owner. Make someone else an Owner first.",
      "MEMBER_ID_AMBIGUOUS": "That member id matches both a customer and a staff member. Reload and try again.",
      "ROLE_CHANGE_CROSSES_TABLES": "Customers and staff are separate memberships. Invite this person to staff instead.",
      "INVALID_MEMBER_KIND": "That member type isn't valid here.",
      "STATUS_NOT_ALLOWED": "That status isn't allowed for this member.",
      "INVALID_WHITELABEL_DOMAIN": "Enter the domain as a bare name, like example.com.",
      "WHITELABEL_HOSTS_REQUIRED": "Include at least one host.",
      "INVALID_WHITELABEL_PREFIX": "Each prefix must be one label: lowercase letters, digits and inner hyphens, no dots.",
      "WHITELABEL_DUPLICATE_PREFIX": "Two hosts use the same prefix. Give each host its own prefix.",
      "WHITELABEL_HOSTNAME_TYPE_UNSUPPORTED": "That host type can't be white-labeled.",
      "WHITELABEL_DOMAIN_RESERVED": "This domain is the platform's or a product's own domain; use a different one.",
      "USER_NOT_FOUND": "No user with that email exists yet.",
      "TENANT_NOT_FOUND": "Tenant not found.",
      "TENANT_INACTIVE": "This tenant is not active.",
      "MEMBER_NOT_FOUND": "Member not found.",
      "ALREADY_ACTIVE_MEMBER": "{{email}} is already a member of this tenant.",
      "INVITATION_ALREADY_PENDING": "An invitation is already pending for {{email}}.",
      "INVITATION_ALREADY_ACCEPTED": "This invitation was already accepted.",
      "PUBLIC_APP_DISABLED": "This tenant's public app is turned off.",
      "APP_HAS_TENANT_OVERRIDES": "Some tenants have a custom build, an offline page or the app turned off. Revert those first.",
      "AFFILIATE_HOST_CONFLICT": "Another app already serves affiliate.<tenant> hosts — change that app's role to Affiliate instead.",
      "DOCROOT_IN_USE_BY_TENANT_OVERRIDE": "This folder is used by a tenant's custom build or offline page. Choose another folder, or remove those first.",
      "OIDC_PROVIDER_DISABLED": "OIDC provider is disabled in this environment.",
      "CANNOT_REMOVE_LAST_TENANT": "An OIDC client must have at least one allowed tenant.",
      "CLIENT_IS_PLATFORM_SCOPED": "This client is platform-scoped — it applies to all products.",
      "OIDC_CLIENT_NOT_ALLOWED_FOR_TENANT": "That OIDC client no longer allow-lists this tenant.",
      "LOGIN_TENANT_NOT_ALLOWED": "The login tenant must be one of the client's allowed tenants.",
      "LOGIN_HOSTNAME_REQUIRED": "The chosen login tenant has no LOGIN/APP hostname.",
      "ALLOWED_TENANTS_REQUIRED": "Select at least one allowed tenant.",
      "REDIRECT_URI_INVALID": "Redirect URIs must use https://.",
      "BRAND_HOST_REQUIRED": "A brand host is required.",
      "INVALID_CLIENT_ID": "Client ID must match ^[a-z0-9][a-z0-9-]{2,63}$.",
      "CLIENT_ID_TAKEN": "That client ID is already in use.",
      "INVALID_REDIRECT_URI": "Redirect URIs must be https://… (no fragment), http://localhost or http://127.0.0.1, or a custom scheme.",
      "INVALID_SCOPE": "Scopes must be a subset of this product's published catalog.",
      "TENANT_NOT_IN_PRODUCT": "That tenant is not in this product.",
      "TENANT_NOT_ACTIVE": "That tenant is not active.",
      "TOO_MANY_HOSTNAMES": "This tenant has too many hostnames for a Turnstile widget.",
      "NO_HOSTNAMES": "There are no hostnames to seed the widget.",
      "WIDGET_NOT_PROVISIONED": "No Turnstile widget is provisioned for this tenant.",
      "TENANT_ORIGIN_MISMATCH": "Origin mismatch — not permitted for this tenant.",
      "RATE_LIMIT_REJECTED": "Too many support sessions opened. Try again in a minute.",
      "RATE_LIMITED": "Too many requests. Please wait a moment and try again.",
      "THEME_CHANGED": "This theme changed elsewhere — reload",
      "THEME_CONTRAST_FAILED": "A changed colour fails WCAG AA contrast. Nothing was saved.",
      "VALIDATION_FAILED": "Some values are invalid.",
      "INVALID_JSON": "The request could not be read.",
      "INVALID_LOCALE": "That language isn't supported.",
      "INVALID_SORT": "That sort option isn't supported.",
      "SERVICE_UNAVAILABLE": "The service is temporarily unavailable. Please try again in a moment.",
      "NETWORK_ERROR": "Network error. Check your connection and try again.",
      "UNKNOWN": "Something went wrong."
    }
  },
  "internalKeys": {
    "title": "Internal API keys",
    "issue": "Issue key",
    "revoke": "Turn off",
    "explanation": "Each key is the X-Internal-Api-Key a product backend presents to saas-auth. A product can have several active keys at once for zero-downtime rotation. The raw key is shown only once at creation — saas-auth stores only a hash.",
    "empty": "No internal keys issued for this product yet.",
    "noLabel": "—",
    "issued": "Internal key issued.",
    "revoked": "Key turned off.",
    "superAdminRequired": "Super admin required to manage internal API keys.",
    "issueTitle": "Issue internal API key",
    "issueBody": "A new high-entropy key is generated by saas-auth and shown once. Give it an optional label to identify which backend it belongs to.",
    "revokeTitle": "Turn off this key?",
    "revokeBody": "Turn off the key {{prefix}}…? A backend still using it will be rejected immediately. This cannot be undone — issue a new key to rotate.",
    "columns": {
      "keyPrefix": "Key prefix",
      "label": "Label",
      "status": "Status",
      "created": "Created",
      "revoked": "Revoked"
    },
    "statuses": {
      "ACTIVE": "Active",
      "REVOKED": "Revoked"
    },
    "fields": {
      "label": "Label (optional)",
      "labelPlaceholder": "e.g. dink-api prod",
      "labelHelper": "A human note shown in the list. Optional."
    },
    "reveal": {
      "title": "Copy this internal key now",
      "prefix": "Prefix: {{prefix}}",
      "secureTransmit": "Deliver this key to the product backend owner over a secure channel (e.g. a password manager share) — it becomes that backend's X-Internal-Api-Key. saas-auth keeps only a hash; this value cannot be retrieved again."
    }
  },
  "productAdmins": {
    "title": "Product admins",
    "explanation": "Product admins administer this product's tenants. Appointing someone requires an existing user — they must sign in once first.",
    "superAdminRequired": "Super admin required to manage product admins.",
    "empty": "No product admins yet.",
    "includeRevoked": "Show revoked",
    "revoked": "Revoked",
    "columns": {
      "email": "Email",
      "role": "Role",
      "granted": "Granted",
      "grantedBy": "Granted by"
    },
    "role": {
      "PRODUCT_ADMIN": "Product admin"
    },
    "actions": {
      "revoke": "Revoke"
    },
    "grant": {
      "action": "Grant product admin",
      "title": "Grant product admin",
      "email": "User email",
      "submit": "Grant",
      "success": "Product admin granted to {{email}}.",
      "noUser": "No user with that email — they must sign in once before they can be appointed.",
      "roleChange": "Revoke then re-grant to change role."
    },
    "revoke": {
      "title": "Revoke product admin?",
      "body": "Remove {{email}} as a product admin. They lose access to this product on their next request.",
      "success": "Product admin access revoked."
    }
  },
  "limitDefinitions": {
    "title": "Resource-limit definitions",
    "explanation": "Each definition is a per-product limit lever (e.g. number of locations). Plans set a value per lever; a tenant without a plan falls back to the default here. The key is fixed once created.",
    "superAdminRequired": "Super admin required to manage resource-limit definitions.",
    "empty": "No limit definitions for this product yet.",
    "noDefault": "—",
    "add": "Add definition",
    "edit": "Edit limit definition",
    "created": "Limit definition created.",
    "updated": "Limit definition updated.",
    "deleted": "Limit definition deleted.",
    "deleteTitle": "Delete limit definition?",
    "deleteBody": "Delete {{key}}? Any plan values set for this lever are affected per the backend. This cannot be undone.",
    "columns": {
      "key": "Key",
      "label": "Label",
      "valueType": "Value type",
      "defaultValue": "Default"
    },
    "valueTypes": {
      "INT": "Integer",
      "BOOL": "Boolean",
      "STRING": "String"
    },
    "fields": {
      "key": "Key",
      "keyHelper": "The stable lever identifier the product backend reads. Can't be changed after create.",
      "label": "Label",
      "valueType": "Value type",
      "valueTypeHelper": "INT (integer), BOOL (true/false), or STRING (free text).",
      "valueTypeImmutable": "Can't be changed after create.",
      "defaultValue": "Default value",
      "defaultHelper": {
        "INT": "The fallback integer when no plan sets this lever. Leave blank for no default.",
        "BOOL": "The fallback (true or false) when no plan sets this lever. Leave blank for no default.",
        "STRING": "The fallback text when no plan sets this lever. Leave blank for no default."
      }
    },
    "validation": {
      "badInt": "Must be a whole number (e.g. 5).",
      "badBool": "Must be true or false."
    }
  },
  "plans": {
    "title": "Resource-limit plans",
    "explanation": "Each plan is a named tier with a value per limit lever. Assign a plan to a tenant to grant its values; a lever a plan leaves unset falls back to the definition default. Edit a plan’s values with the tune control.",
    "superAdminRequired": "Super admin required to manage resource-limit plans.",
    "empty": "No plans for this product yet.",
    "noDescription": "—",
    "add": "Add plan",
    "edit": "Edit plan",
    "editLimits": "Edit limit values",
    "created": "Plan created.",
    "updated": "Plan updated.",
    "deleted": "Plan deleted.",
    "limitsSaved": "Plan limits saved.",
    "deleteTitle": "Delete plan?",
    "deleteBody": "Delete {{name}}? A tenant assigned this plan must be reassigned first per the backend. This cannot be undone.",
    "limitsTitle": "Edit limit values — {{name}}",
    "limitsExplanation": "Set this plan’s value for each lever. Leave a number or text lever blank to use the definition default.",
    "noDefinitions": "This product has no limit definitions yet. Add definitions above before setting plan values.",
    "limitDefault": "{{value}} (default)",
    "limitNone": "—",
    "columns": {
      "name": "Name",
      "description": "Description",
      "active": "Active",
      "limits": "Limits"
    },
    "statuses": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "fields": {
      "name": "Name",
      "description": "Description",
      "descriptionHelper": "Optional. Leave blank for none.",
      "active": "Active"
    },
    "validation": {
      "badInt": "Must be a whole number (e.g. 5)."
    }
  },
  "ghl": {
    "title": "GoHighLevel integration",
    "explanation": "This config lets the tenant's product backend operate against the tenant's GoHighLevel account. The private integration token is write-only — it is never displayed again after you save it.",
    "superAdminRequired": "Super admin required to manage the GHL integration.",
    "empty": "No GHL integration configured for this tenant yet.",
    "saved": "GHL integration saved.",
    "deleted": "GHL integration removed.",
    "create": "Create integration",
    "delete": "Delete integration",
    "deleteTitle": "Delete GHL integration?",
    "deleteBody": "This removes the tenant's GHL integration. The tenant's product backend will no longer be able to operate against its GoHighLevel account until a new integration is configured. This cannot be undone.",
    "locationLabel": "Location ID",
    "tokenSet": "Token set ({{suffix}})",
    "tokenUnset": "No token stored",
    "created": "Created",
    "updated": "Updated",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "fields": {
      "locationId": "Location ID",
      "locationIdPlaceholder": "e.g. loc_abc123",
      "token": "Private integration token",
      "tokenPlaceholder": "Paste the GHL private integration token",
      "tokenReplacePlaceholder": "Enter a new token to replace",
      "tokenHelper": "Write-only — shown only as a masked suffix after saving.",
      "tokenReplaceHelper": "Leave blank to keep the current token. Type a value only to replace it.",
      "active": "Active"
    },
    "errors": {
      "tokenRequired": "A private integration token is required."
    }
  },
  "captcha": {
    "title": "Turnstile / Captcha",
    "explanation": "Cloudflare Turnstile protection for this tenant's login and app hostnames. The secret is write-only — it is never displayed again after you save it.",
    "superAdminRequired": "Super admin required to manage Captcha settings.",
    "saved": "Captcha settings saved.",
    "provisioned": "Turnstile widget provisioned.",
    "secretRotated": "Widget secret rotated.",
    "removed": "Captcha config removed.",
    "provision": "Provision widget",
    "rotateSecret": "Rotate secret",
    "remove": "Remove captcha config",
    "removeTitle": "Remove captcha config?",
    "removeBody": "Removes this tenant's Captcha config — site key, secret, and enforce — and cannot be undone.",
    "secretSet": "Secret set ({{suffix}})",
    "siteKeyUnset": "Not provisioned yet",
    "secretUnset": "No secret stored",
    "manageInCloudflare": "Manage in Cloudflare",
    "info": {
      "status": "Status",
      "provisioned": "Provisioned",
      "notProvisioned": "Not provisioned",
      "widget": "Widget",
      "widgetDetail": "{{mode}} · {{count}} domain(s)"
    },
    "widget": {
      "provisioned": "Widget provisioned — {{mode}} mode, {{count}} domain(s).",
      "notProvisioned": "No Turnstile widget provisioned for this tenant.",
      "unavailable": "Cloudflare widget temporarily unavailable — try again shortly."
    },
    "fields": {
      "enabled": "Enabled",
      "enforce": "Enforcement",
      "enforceHelper": "Inherit the global policy, observe only (no block), or enforce for this tenant.",
      "siteKey": "Site key",
      "siteKeyPlaceholder": "e.g. 0x4AAA…",
      "siteKeyHelper": "Public Turnstile site key. Populated automatically after provisioning.",
      "secret": "Secret key",
      "secretPlaceholder": "Paste the Turnstile secret key",
      "secretReplacePlaceholder": "Enter a new secret to replace",
      "secretHelper": "Write-only — never displayed after saving.",
      "secretReplaceHelper": "Leave blank to keep the current secret. Type a value only to replace it."
    },
    "enforce": {
      "inherit": "Inherit global",
      "observe": "Observe",
      "enforce": "Enforce"
    },
    "errors": {
      "tooManyHostnames": "This tenant has more than 10 APP/LOGIN hostnames — a Turnstile widget supports at most 10. Remove some hostnames and try again.",
      "noHostnames": "This tenant has no APP or LOGIN hostname to seed the Turnstile widget. Add a hostname first.",
      "widgetNotProvisioned": "No Turnstile widget is provisioned for this tenant yet. Provision a widget first."
    },
    "hostnamesSync": {
      "button": "Sync Cloudflare",
      "notProvisionedTooltip": "No Turnstile widget provisioned for this tenant.",
      "synced": "Turnstile hostnames synced.",
      "registered": "Registered on Turnstile",
      "notRegistered": "Not registered on Turnstile"
    }
  },
  "entraSso": {
    "title": "Microsoft SSO",
    "intro": "How this tenant's users sign in — Microsoft Entra (Azure AD) single sign-on. Configure the customer's registration, the redirect URI they register, and this tenant's login-method override.",
    "superAdminRequired": "Super admin required to manage Microsoft SSO.",
    "saved": "Microsoft SSO configuration saved.",
    "removed": "Microsoft SSO configuration removed.",
    "expiryCleared": "Secret expiry cleared.",
    "remove": "Remove Microsoft SSO config",
    "removeTitle": "Remove Microsoft SSO configuration?",
    "removeBody": "This deletes the tenant's Microsoft Entra SSO configuration (directory ID, application ID, and client secret). If this tenant is set to Microsoft-only login, users will be unable to sign in until it is reconfigured; a platform super-admin can temporarily re-enable password login as a break-glass recovery (SASATH-0111). This cannot be undone.",
    "clearExpiry": "Clear expiry",
    "secretStatus": "Stored secret: {{state}}",
    "secret": {
      "masked": "•••• {{suffix}}",
      "set": "Set",
      "notSet": "Not set"
    },
    "card1": {
      "title": "Microsoft SSO configuration",
      "explanation": "Enter the values from the customer's Azure app registration. The client secret is write-only — after saving it is only ever shown as a masked suffix.",
      "runbookNote": "Customer onboarding steps: docs/runbooks/entra-sso-customer-onboarding.md"
    },
    "card2": {
      "title": "Redirect URI to register in Azure",
      "instruction": "Register the selected URI in Azure as a Web redirect URI. To switch, add the other URI in Azure first (Azure allows several), then switch here.",
      "choiceLabel": "Redirect URI to use",
      "options": {
        "system": "System",
        "whitelabel": "Whitelabel"
      },
      "current": "Current",
      "fieldLabel": {
        "system": "System redirect URI",
        "whitelabel": "Whitelabel redirect URI"
      },
      "copyAria": {
        "system": "Copy System redirect URI",
        "whitelabel": "Copy Whitelabel redirect URI"
      },
      "whitelabelUnavailable": "Activate a white-label domain with an auth host first",
      "systemUnavailable": "Not available",
      "currentUnavailable": "The current choice has no available host. Choose System.",
      "save": "Save redirect choice",
      "saved": "Redirect URI choice saved.",
      "loadError": "Couldn't load the redirect URI",
      "retry": "Retry"
    },
    "card3": {
      "title": "Login methods for this tenant",
      "explanation": "Set a per-tenant override of the login methods this tenant may use. This overrides only this tenant; it never changes the shared brand. Clear it to inherit the brand default.",
      "noOverride": "No per-tenant override — this tenant inherits its brand's login methods.",
      "lockoutWarning": "This tenant cannot use password login. If Microsoft SSO breaks or the client secret expires, users can be locked out; recovery requires a platform super-admin break-glass (SASATH-0111).",
      "save": "Save login methods",
      "clear": "Clear override (inherit brand default)"
    },
    "providers": {
      "password": "Password",
      "google": "Google",
      "microsoft": "Microsoft"
    },
    "fields": {
      "tenantId": "Directory (tenant) ID",
      "clientId": "Application (client) ID",
      "clientSecret": "Client secret",
      "clientSecretHelper": "Write-only — shown only as a masked suffix after saving. Leave blank to keep the current secret.",
      "expiresAt": "Client secret expiry (optional)",
      "expiresAtHelper": "Optional. From the Azure secret's expiry; drives the platform expiry warning.",
      "domainHint": "Domain hint (optional)",
      "domainHintHelper": "Sends users straight to this organization's Microsoft sign-in. Invitations to addresses on this domain are pre-authorized: no email is sent, and they activate on the person's first Microsoft sign-in. Other addresses get a normal invitation email."
    },
    "jit": {
      "label": "Automatically add people from this Microsoft directory",
      "helper": "Anyone who can sign in with this tenant's Microsoft directory, including its guests, gets access to the employee app on their first sign-in. The admin app stays by invitation; to pre-place an admin, invite them (an address on the domain hint needs no email). To block someone, suspend them; removing them lets them back in on their next sign-in.",
      "confirmTitle": "Let everyone in this Microsoft directory in?",
      "confirmBody": "Anyone who can sign in with this tenant's Microsoft directory, including its guests, will get access to the employee app on their first sign-in, without an invitation.",
      "confirmAction": "Turn on and save"
    },
    "overrideSaved": "Login methods override saved.",
    "overrideCleared": "Override cleared — this tenant now inherits its brand's login methods.",
    "confirmLockoutTitle": "Force non-password login for this tenant?",
    "confirmLockoutBody": "This tenant will no longer allow password login. If Microsoft SSO breaks or the client secret expires, all users can be locked out; recovery requires a platform super-admin break-glass (SASATH-0111). Continue?",
    "confirmLockoutConfirm": "Force these login methods",
    "errors": {
      "tenantIdRequired": "The directory (tenant) ID is required.",
      "clientIdRequired": "The application (client) ID is required.",
      "secretRequired": "A client secret is required to create the configuration.",
      "lockoutIncomplete": "Complete the Microsoft SSO configuration (directory ID, application ID, client secret) before forcing Microsoft-only, or every user in this tenant will be locked out."
    }
  },
  "tenantPlan": {
    "title": "Resource-limit plan",
    "explanation": "Assign a resource-limit plan to grant this tenant the plan's values; a lever the plan leaves unset falls back to the definition default. The product backend's server-to-server read is authoritative — the effective limits below are a display convenience.",
    "superAdminRequired": "Super admin required to manage the resource-limit plan.",
    "noProduct": "Assign a product to this tenant before managing its resource-limit plan.",
    "noPlans": "No plans are defined for this product yet. Create a plan on the product screen first.",
    "currentPlan": "Current plan",
    "noPlan": "No plan assigned",
    "selectLabel": "Plan",
    "inactiveOption": "{{name}} (inactive)",
    "assign": "Assign plan",
    "unassign": "Unassign plan",
    "assigned": "Plan assigned.",
    "unassigned": "Plan removed.",
    "unassignTitle": "Unassign plan?",
    "unassignBody": "This removes the tenant's plan assignment. Its effective limits fall back to the definition defaults until a plan is assigned again.",
    "effectiveTitle": "Effective limits",
    "effectiveEmpty": "No effective limits — this product has no definitions with a plan value or a default.",
    "boolEnabled": "Enabled",
    "boolDisabled": "Disabled",
    "columns": {
      "lever": "Lever",
      "value": "Effective value",
      "source": "Source"
    },
    "source": {
      "override": "Override",
      "plan": "Plan",
      "default": "Default"
    }
  },
  "integrationSettings": {
    "title": "Integration Settings (pass-through)",
    "explanation": "Generic per-tenant integration configuration the tenant's product backend reads. saas-admin stores these opaque values and does not interpret them. Values marked secret are write-only — shown only as a masked suffix after saving. This is separate from the GoHighLevel integration above.",
    "superAdminRequired": "Super admin required to manage integration settings.",
    "empty": "No integration settings configured for this tenant yet.",
    "noKeys": "No keys in this group yet.",
    "searchPlaceholder": "Search keys by name or value",
    "searchAriaLabel": "Search integration keys",
    "noMatches": "No keys match your search.",
    "table": {
      "ariaLabel": "Integration keys",
      "key": "Key",
      "value": "Value",
      "actions": "Actions"
    },
    "active": "Active",
    "addGroup": "Add group",
    "deleteGroup": "Delete group",
    "deleteGroupTitle": "Delete group?",
    "deleteGroupBody": "This removes the group and all of its keys (including any stored secrets). The tenant’s product backend will no longer read these settings. This cannot be undone.",
    "addKey": "Add key",
    "replace": "Replace",
    "clear": "Clear",
    "groupAdded": "Group added.",
    "groupDeleted": "Group deleted.",
    "keyAdded": "Key added.",
    "keyUpdated": "Key updated.",
    "keyRemoved": "Key removed.",
    "secret": {
      "set": "Set",
      "notSet": "Not set",
      "masked": "•••• {{suffix}}"
    },
    "fields": {
      "groupName": "Group name",
      "key": "Key",
      "value": "Value",
      "newSecret": "New secret value",
      "isSecret": "Secret",
      "replaceHelper": "Write-only. Leave blank to keep the current secret."
    },
    "errors": {
      "nameRequired": "A name is required.",
      "nameTooLong": "Use at most 100 characters.",
      "nameInvalidChars": "Use only letters, numbers, and the characters . _ -",
      "duplicateKey": "A key with that name already exists.",
      "duplicateGroup": "A group with that name already exists."
    }
  },
  "snackbar": {
    "tenantCreated": "Tenant created.",
    "tenantUpdated": "Tenant updated.",
    "productCreated": "Product created.",
    "statusUpdated": "Status updated.",
    "signupModeUpdated": "Signup mode updated.",
    "brandAssigned": "Brand assigned.",
    "brandCleared": "Brand cleared.",
    "hostnameAdded": "Hostname registered.",
    "hostnameRemoved": "Hostname removed.",
    "hostnamePrimaryUpdated": "Primary hostname updated.",
    "hostnameDnsVerified": "DNS verified — hostname is now active.",
    "hostnameAppUpdated": "App assignment updated.",
    "memberAdded": "Member added.",
    "memberUpdated": "Member updated.",
    "memberRemoved": "Member removed.",
    "invitationSent": "Invitation sent to {{email}}.",
    "invitationRevoked": "Invitation revoked.",
    "templateSaved": "Template mapping saved.",
    "templateRemoved": "Template mapping removed; reverted to default.",
    "brandCreated": "Brand created.",
    "brandUpdated": "Brand updated.",
    "brandDeleted": "Brand deleted.",
    "logoImageUploaded": "Logo uploaded.",
    "faviconImageUploaded": "Favicon uploaded.",
    "heroImageUploaded": "Hero image uploaded.",
    "productCreated": "Product created.",
    "productUpdated": "Product updated.",
    "productDeleted": "Product deleted.",
    "appCreated": "App created.",
    "appUpdated": "App updated.",
    "appDeleted": "App deleted.",
    "oidcCreated": "OIDC client created.",
    "secretRotated": "Secret rotated."
  },
  "externalAuth": {
    "showAnyway": "Show anyway",
    "hide": "Hide",
    "notes": {
      "oidc": "This product authenticates externally — OIDC clients aren't used here.",
      "brands": "This product authenticates externally — tenant brands aren't applied to its login.",
      "login": "This product authenticates externally — platform login/branding guidance doesn't apply.",
      "guestSignup": "This product authenticates externally — the guest-signup login link isn't used.",
      "defaultBrand": "This product authenticates externally — a default brand isn't used."
    }
  },
  "palette": {
    "hint": "Type to search tenants, brands and users",
    "noMatches": "No matches"
  }
}
